<template>
  <div id="formPedido">
    <b-row class="pt-3">
      <b-col sm="9 pl-0 title" id="titlePage">{{title || "Título não informado"}}</b-col>
      <b-col class="right pr-0 btnAcoesPag">
        <b-button variant="secondary" v-on:click="confSairSemSalvar()"><i class="fas fa-arrow-left"></i> Voltar</b-button>
      </b-col>
      <b-col  class="right btnAcoesPag pr-0"  v-if="pedido.isEditavel">
        <b-button class="btnSalvar" v-on:click="tentaSalvar()"><i class="fas fa-save"></i> Salvar</b-button>
      </b-col>
    </b-row>
    <div class="card shadow mt-2" id="pedDados">
      <div id="progBar" :style="cor">
        <div class="progressbar">
          <button
            :disabled=desabilitaEdicao()
            v-for="st in this.status" :key="st.idStatus" :class="[st.classe, {'color': (st.idStatus !== pedido.statusGoSales), 'colorSelec': (st.idStatus === pedido.statusGoSales)}]"
            @click="selecionarStatus(st.idStatus)"
            :style="st.idStatus !== pedido.statusGoSales ? cor : corSelec"
          >{{st.descricao}}</button><!---{{st.codigo}}-->
          <!--v-for="st in this.status" :key="st.idStatus" :class="[st.classe, {'color': (st.idStatus !== pedido.statusGoSales), 'colorSelec': (st.idStatus === pedido.statusGoSales)}]"-->
        </div>
      </div>
      <b-card>
        <b-card-text>
          <!--imprimir serv ped {{pedido}}-->
          <form class="w-100">
            <div class="form-row">
              <div class="col-md-6 mb-3">
                <div class="form-row mt-3 ml-0 mr-0">
                  <div class="title2 titleFluid col-10 pl-0"><p>DADOS DO CLIENTE</p></div>
                  <div class="col-2" id="imgOrigem" v-if="pedido.canal">
                    <img :src="pedido.canal.url" alt="" />
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-row">
                  <div class="mb-2 col-4">
                    <label for="input-idPedido" class="left">Nº do Pedido</label>
                    <b-form-input
                      class="txtRight"
                      size="sm"
                      id="input-idPedido"
                      v-model="pedido.numeroPedido"
                      placeholder="Nº Pedido"
                      disabled
                    ></b-form-input>
                  </div>
                  <div class="mb-2 col-4">
                    <label for="input-idOrcamento" class="left">Nº Orçamento</label>
                    <b-form-input
                      class="txtRight"
                      size="sm"
                      id="input-idOrcamento"
                      v-model="pedido.numeroOrcamento"
                      placeholder="Nº Orçamento"
                      disabled
                    ></b-form-input>
                  </div>
                  <div class="mb-2 col-4">
                    <label for="input-idGoSales" class="left">ID GoSales</label>
                    <b-form-input
                      class="txtRight"
                      size="sm"
                      id="input-idGoSales"
                      v-model="pedido.id"
                      placeholder="Nº Pedido"
                      disabled
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-1">
                <label for="input-fantasia" class="left" v-if="!empresaKatec">Fantasia</label>
                <label for="input-fantasia" class="left" v-else>Cliente Reduzido</label>
                <b-form-input
                  v-if="!empresaKatec"
                  size="sm"
                  id="input-fantasia"
                  v-model="pedido.cliente.fantasia"
                  placeholder="Fantasia"
                  disabled
                ></b-form-input>
                <b-form-input
                  v-else
                  size="sm"
                  id="input-fantasia"
                  v-model="pedido.cliente.fantasia"
                  placeholder="Cliente Reduzido"
                  disabled
                ></b-form-input>
              </div>
              <div class="col-md-6 mb-1">
                <label for="input-cnpj" class="left" v-if="tipoClienteJuridico">CNPJ</label>
                <label for="input-cpf" class="left" v-else>CPF</label>
                <b-form-input
                  v-if="pedido.cliente.cnpjCpf && pedido.cliente.cnpjCpf.length >= 14"
                  size="sm"
                  type="text"
                  id="input-cnpj"
                  v-model="pedido.cliente.cnpjCpf"
                  placeholder="CNPJ"
                  disabled
                ></b-form-input>
                <b-form-input
                  v-else
                  size="sm"
                  type="text"
                  id="input-cpf"
                  v-model="pedido.cliente.cnpjCpf"
                  placeholder="CPF"
                  disabled
                ></b-form-input>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6 mb-1">
                <label for="input-razaoSocial" class="left">Razão Social</label>
                <b-form-input
                  size="sm"
                  id="input-razaoSocial"
                  v-model="pedido.cliente.razaoSocial"
                  placeholder="Razão Social"
                  disabled
                ></b-form-input>
              </div>
              <div class="col-md-6">
                <div class="form-row">
                  <div class="col-4 mb-1"> <!--<div class="col-md-2">-->
                    <label for="input-ddd" class="left">DDD</label>
                    <b-form-input
                      size="sm"
                      id="input-ddd"
                      v-model="pedido.cliente.ddd"
                      placeholder="DDD"
                      :disabled="desabilitaEdicao()"
                      v-validate="'min:4'"
                      v-mask="'(##)'"
                      :class="{'input': true, 'invalid': errors.has('ddd')}"
                      name="ddd"
                    ></b-form-input>
                  </div>
                  <div class="col-8 mb-1"> <!--<div class="col-md-4">-->
                    <label for="input-telefone" class="left">Telefone</label>
                    <b-form-input
                      size="sm"
                      id="input-telefone"
                      v-model="pedido.cliente.telefone"
                      placeholder="Telefone"
                      :disabled="desabilitaEdicao()"
                      v-validate="'min:9'"
                      v-mask="['####-####', '#####-####']"
                      :class="{'input': true, 'invalid': errors.has('telefone')}"
                      name="telefone"
                    ></b-form-input>
                    <span v-show="errors.has('telefone')" class="invalid">Campo obrigatório | Mínimo 8 caracteres</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mt-5 mb-5" id="dadosPedido">
              <b-col>
                <b-row class="mb-3">
                  <b-col md="12" class="titleFluid p-0"><p>DADOS DO PEDIDO</p></b-col>
                </b-row>
                <div class="form-row mb-4" v-if="this.pedido.motivoCancelamento && this.pedido.statusGoSales === 3" id="cardMotCanc">
                  <b-card class="w-100"
                    header-bg-variant="secondary"
                    bg-variant="light"
                    header-text-variant="white"
                    text-variant="dark"
                    header="Motivo para o cancelamento do Pedido"
                    >
                    <b-card-text>{{this.pedido.motivoCancelamento}}</b-card-text>
                  </b-card>
                </div>
                <div class="form-row">
                  <div class="col-md-4 mb-3">
                    <label for="input-emissao" class="left">Data de Emissão</label>
                    <b-form-input
                      disabled
                      size="sm"
                      id="input-emissao"
                      v-model="pedido.emissao"
                      placeholder="Data de Emissão">
                    ></b-form-input>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="input-tabelaPreco" class="left labelSelect">Tabela de Preço</label>
                    <model-list-select
                      id="input-tabelaPreco"
                      :list="dadosTabela.tabelasPreco"
                      v-model="pedido.tabelaPreco"
                      option-value="codigo"
                      option-text="descricao"
                      placeholder="Selecione ou digite para pesquisar"
                      :isDisabled=desabilitaEdicao()>
                    </model-list-select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="input-formaPagto" class="left labelSelect">Forma de Pagamento</label>
                    <model-list-select
                      id="input-formaPagto"
                      :list="dadosTabela.formaPagtos"
                      v-model="pedido.formaPagto"
                      option-value="codigo"
                      option-text="descricao"
                      placeholder="Selecione ou digite para pesquisar"
                      :isDisabled=desabilitaEdicao()>
                    </model-list-select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-4 mb-3">
                    <label for="input-condPagto" class="left labelSelect">Condição de Pagamento</label>
                    <model-list-select
                      id="input-condPagto"
                      :list="dadosTabela.condPagtos"
                      v-model="pedido.condPagto"
                      option-value="codigo"
                      option-text="descricao"
                      placeholder="Selecione ou digite para pesquisar"
                      :isDisabled=desabilitaCondicaoPagto()>
                    </model-list-select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="input-fretePed" class="left labelSelect">Frete</label>
                    <model-list-select
                      id="input-fretePed"
                      :list="dadosTabela.fretes"
                      v-model="pedido.tipoFrete"
                      option-value="codigo"
                      option-text="descricao"
                      placeholder="Selecione ou digite para pesquisar"
                      :isDisabled=desabilitaEdicao()>
                    </model-list-select>
                  </div>
                  <div class="col-md-4 mb-3">
                    <label for="input-transportadora" class="left labelSelect" v-if="empresaKatec">Transp./Redespacho</label>
                    <label for="input-transportadora" class="left labelSelect" v-else>Transportadora</label>
                    <model-list-select
                      id="input-transportadora"
                      :list="dadosTabela.transportadoras"
                      v-model="pedido.transportadora"
                      option-value="codigo"
                      :custom-text="descTabela"
                      placeholder="Selecione ou digite para pesquisar"
                      :isDisabled="desabilitaEdicao()">
                    </model-list-select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-4 mb-3">
                    <label for="input-representante" class="left labelSelect">Representante</label>
                    <model-list-select
                      id="input-representante"
                      :list="dadosTabela.representante"
                      v-model="pedido.representante"
                      option-value="codigo"
                      :custom-text="descRepresentante"
                      placeholder="Selecione ou digite para pesquisar"
                      :isDisabled="desabilitaRepresentante()">
                    </model-list-select>
                  </div>
                  <div class="col-md-4">
                    <label for="input-numeroPedidoCompra" class="left">Número Pedido Compra</label>
                    <b-form-input
                      size="sm"
                      id="input-numeroPedidoCompra"
                      v-model="pedido.numeroPedidoCompra"
                      placeholder="Número do pedido de compra"
                      :disabled="desabilitaEdicao()"
                    ></b-form-input>
                  </div>
                </div>
                <div class="form-row mt-3">
                  <div class="col-md-4">
                    <label for="input-cliente-industrial" class="left">Cliente Industrializador</label>
                    <b-form-input
                      size="sm"
                      v-model="clienteIndustrializadorNome"
                      id="input-cliente-industrial"
                      placeholder="Cliente Industrial"
                      :disabled="true"
                    ></b-form-input>
                  </div>
                  <div class="col-md-1" style="margin-top: 32px">
                    <b-button class="btn btn-secondary" size="sm" @click="adicionarClienteInd()" :disabled="desabilitaEdicao()"><i class="fas fa-search"></i></b-button>
                  </div>
                  <div class="col-md-1" style="margin-top: 32px">
                    <b-button class="btn btn-secondary" size="sm" @click="limparClientInd()" :disabled="desabilitaEdicao()"><i class="fas fa-eraser"></i></b-button>
                  </div>
                </div>
              </b-col>
            </div>
            <div class="form-row mb-5" id="cardObs">
              <b-col>
                <b-row class="mb-3">
                  <b-col md="10" class="titleFluid"><p>OBSERVAÇÕES</p></b-col>
                  <!-- <b-col md="1" class="p-0 txtRight btnAdd"><b-button variant="secondary" class="offset-1 btn-circle" @click="newObs" v-show="!desabilitaEdicao()"><i class="fas fa-plus"></i></b-button></b-col> -->
                  <b-col md="2" class="p-0 txtRight"><b-button variant="secondary" class="col-md-8" @click="newObs" v-show="!desabilitaEdicao()"><i class="fas fa-plus"></i> Nova</b-button></b-col>
                </b-row>
                <b-row>
                  <b-card border-variant="light"
                    v-for="(obsPed, index) in pedido.observacoes"
                    :key="index"
                    :header="obsPed.tipoObservacao.descricao"
                    class="shadow2 col-md-10 p-0 m-z-auto mb-3">
                    <b-card-text>
                      <div class="form-row ml-0 mr-0">
                        <div class="txtLeft txtBreakAll">
                          {{obsPed.observacao}}
                        </div>
                      </div>
                    </b-card-text>
                    <div class="form-row" id="btnsObs">
                      <div class="col-9"></div>
                      <div class="col-3">
                        <div class="form-row">
                          <b-button variant="secondary" class="col-md-6" v-on:click="alterarObs(obsPed, index)" v-show="!desabilitaEdicao()">Alterar</b-button>
                          <b-button variant="danger" class="col-md-6" v-on:click="confirmaExclusaoObs(index)" v-show="!desabilitaEdicao()">Remover</b-button>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </b-row>
              </b-col>
            </div>
            <div class="form-row mt-5 mb-5" id="pedDescontosPed" v-if="!desabilitaEdicao()">
              <b-col v-if="this.pedido.itens.length > 0 ">
                <b-row class="mb-3">
                  <b-col md="12" class="titleFluid"><p>DESCONTO</p></b-col>
                </b-row>
                <div class="form-row">
                  <div class="col-md-8">
                    <div class="form-row">
                      <div class="col-md-6">
                        <b-form-group class="mb-0">
                          <div class="form-row">
                            <label label-for="descPerc" class="col-7 mt-1 mb-0">Percentual %</label>
                            <b-form-input
                              class="col-5"
                              size="sm"
                              id="input-percentual"
                              v-model="desconto.percentual"
                              v-on:keyup="calculaValorDesconto(1)"
                              placeholder="Desc."
                              :disabled="this.desconto.valor !== '0,00'"
                            ></b-form-input>
                          </div>
                        </b-form-group>
                      </div>
                      <div class="col-md-6">
                        <b-form-group class="mb-0">
                          <div class="form-row">
                            <label class="col-5 mt-1 mb-0">Valor</label>
                            <b-form-input
                              class="col-5"
                              size="sm"
                              id="input-desconto"
                              v-model.lazy="desconto.valor"
                              v-money="money"
                              v-on:keyup="calculaValorDesconto(2)"
                              placeholder="Valor"
                              :disabled="this.desconto.percentual > 0"
                            ></b-form-input>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-row">
                      <div class="col-6">
                        <b-button variant="secondary" size="sm" @click="aplicarDesconto()" :disabled="!habilitaDescGeral">Aplicar</b-button>
                      </div>
                      <div class="col-6">
                        <b-button variant="danger" size="sm" @click="limparDesconto()">Limpar</b-button>
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </div>
            <div class="form-row mt-5 mb-5 ml-0 mr-0 w-100">
              <div class="w-100">
                <b-row class="mb-3">
                  <b-col md="12" class="titleFluid p-0"><p>TOTAIS</p></b-col>
                </b-row>
                <div id="pedTotaisPed">
                  <div class="form-row">
                    <div class="col-md-3 txtRight">
                      <label id="labelDescWeb"><b>DESCONTO</b></label>
                      <label id="labelDescMob"><b>DESC</b></label>
                      <p>{{formatterValue(pedido.totais.valorDesconto)}}</p>
                    </div>
                    <div class="col-md-3 txtRight">
                      <label><b>IPI</b></label>
                      <p>{{formatterValue(pedido.totais.valorIPI)}}</p>
                    </div>
                    <div class="col-md-3 txtRight">
                      <label><b>ICMS ST</b></label>
                      <p>{{formatterValue(pedido.totais.valorICMSST)}}</p>
                    </div>
                    <div class="col-md-3 txtRight">
                      <label><b>TOTAL</b></label>
                      <p>{{formatterValue(pedido.totais.valorTotal)}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row mt-5 mb-5">
              <b-col>
                <b-row class="mb-3">
                  <b-col md="10" class="titleFluid"><p>ITENS PEDIDO</p></b-col>
                  <!-- <b-col md="1" class="p-0 txtRight btnAdd"><b-button variant="secondary" class="offset-1 btn-circle" @click="addItem()" v-show="!desabilitaEdicao()"><i class="fas fa-plus"></i></b-button></b-col> -->
                  <b-col md="2" class="p-0 txtRight"><b-button variant="secondary" class="col-md-8" @click="addItem()" v-show="!desabilitaEdicao()"><i class="fas fa-plus"></i> Novo</b-button></b-col>
                </b-row>
                <b-row id="scrollItens">
                  <b-row id="cardWeb">
                    <b-card border-variant="light" class="shadow2 col-md-11 mb-3 cardItem" v-for="item in pedido.itens" :key="item.chaveErp">
                      <b-card-text>
                        <b-row>
                          <b-col cols="2" class="imgItem">
                            <img v-if="item.url" :src="item.url" img-alt="Image" />
                            <!-- <b-card v-if="item.url" :img-src="item.url" img-alt="Image" /> -->
                            <img class="semImagemItem card-img" src="@/assets/sem-imagem.png" v-else alt="" />
                          </b-col>
                          <b-col cols="10" class="txtLeft p-0 dadosItem">
                            <b-row>
                              <b-col cols="9" v-if="!empresaKatec"><b>Item: </b>{{item.codProduto}}</b-col>
                              <b-col cols="9" v-else><b>Código: </b>{{item.codProduto}}</b-col>
                              <b-col cols="3" class="txtRight"><b>Qtde:</b> {{formatQtde(item.qtdVenda)}} </b-col>
                            </b-row>
                            <b-row>
                              <b-col cols="12" class="txtLeft"><b>Tamanho:</b> {{item.descTamanho}}</b-col>
                              <b-col cols="12" class="txtLeft"><b>Cor:</b> {{item.descCor}}</b-col>
                              <b-col cols="12" class="txtLeft" v-if="!empresaKatec"><b>Descrição:</b> {{item.descricao}}</b-col>
                              <b-col cols="12" class="txtLeft" v-else><b>Produto:</b> {{item.descricao}}</b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-card-text>
                      <div class="text-divider mb-5"></div>
                      <div class="row">
                        <b-col>
                          <label><b>Preço Tab.</b></label>
                          <p>{{formatterValue(item.valorTabela)}}</p>
                        </b-col>
                        <b-col>
                          <label><b>Desc.</b></label>
                          <p>{{formatterValue(item.valorDesconto)}}</p>
                        </b-col>
                        <b-col>
                          <label><b>Preço Unit.</b></label>
                          <p>{{formatterValue(item.valorUnitario)}}</p>
                        </b-col>
                        <b-col>
                          <label><b>IPI</b></label>
                          <p>{{formatterValue(item.valorIPI)}}</p>
                        </b-col>
                        <b-col>
                          <label><b>ICMS ST</b></label>
                          <p>{{formatterValue(item.valorICMSST)}}</p>
                        </b-col>
                        <b-col>
                          <label><b>Total</b></label>
                          <p>{{formatterValue(item.totalItem)}}</p>
                        </b-col>
                      </div>
                      <b-row v-if="pedido.isEditavel">
                        <b-col class="offset-8 col-md-2">
                          <b-button variant="danger" size="sm" v-on:click="confirmaExclusao(item.id)">Excluir</b-button>
                        </b-col>
                        <b-col class="col-md-2">
                          <b-button variant="secondary" size="sm" v-on:click="editarItemPedido(item)">Editar</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-row>
                  <b-row id="cardMob">
                    <b-card border-variant="light" class="shadow2 col-md-11 mb-3 cardItem" v-for="item in pedido.itens" :key="item.chaveErp">
                      <b-card-text>
                        <b-row>
                          <b-col cols="2" class="imgItem">
                            <img v-if="item.url" :src="item.url" img-alt="Image" />
                            <!-- <b-card v-if="item.url" :img-src="item.url" img-alt="Image" /> -->
                            <img class="semImagemItem card-img" src="@/assets/sem-imagem.png" v-else alt="" />
                          </b-col>
                          <b-col cols="10" class="txtLeft p-0 dadosItem">
                            <b-row>
                              <b-col cols="12"><b>Qtde:</b> {{item.qtdVenda}} </b-col>
                              <b-col cols="12"><b>Item: </b>{{item.codProduto}}</b-col>
                              <b-col cols="12"><b>Tamanho:</b> {{item.descTamanho}}</b-col>
                              <b-col cols="12"><b>Cor:</b> {{item.descCor}}</b-col>
                              <b-col cols="12"><b>Descrição:</b> {{item.descricao}}</b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-card-text>
                      <div class="text-divider mb-5"></div>
                      <div class="row">
                        <b-col cols="4">
                          <label><b>Preço Tab.</b></label>
                          <p>{{formatterValue(item.valorTabela)}}</p>
                        </b-col>
                        <b-col cols="4">
                          <label><b>Desc.</b></label>
                          <p>{{formatterValue(item.valorDesconto)}}</p>
                        </b-col>
                        <b-col cols="4">
                          <label><b>Preço Unit.</b></label>
                          <p>{{formatterValue(item.valorUnitario)}}</p>
                        </b-col>
                      </div>
                      <div class="row mt-2">
                        <b-col cols="4">
                          <label><b>IPI</b></label>
                          <p>{{formatterValue(item.valorIPI)}}</p>
                        </b-col>
                        <b-col cols="4">
                          <label><b>ICMS ST</b></label>
                          <p>{{formatterValue(item.valorICMSST)}}</p>
                        </b-col>
                        <b-col cols="4">
                          <label><b>Total</b></label>
                          <p>{{formatterValue(item.totalItem)}}</p>
                        </b-col>
                      </div>
                      <b-row v-if="pedido.isEditavel" id="btnsItem">
                        <b-col class="offset-4 col-4">
                          <b-button variant="danger" size="sm" v-on:click="confirmaExclusao(item.id)">Excluir</b-button>
                        </b-col>
                        <b-col class="col-4">
                          <b-button variant="secondary" size="sm" v-on:click="editarItemPedido(item)">Editar</b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-row>
                </b-row>
              </b-col>
            </div>
            <div v-if="btnSalvar" class="mt-4 mg-auto" id="btnImpressao">
              <b-button variant="secondary" class="col-3" v-on:click="imprimePedido2"><i class="fas fa-print"></i> Visualizar Impressão</b-button>
            </div>
          </form>
        </b-card-text>
      </b-card>
      <!--- MODAL DE OBSERVACAO --->
      <b-modal id="modal-scoped"
        v-model="modalObs"
        ok-title="Salvar"
        ok-variant="primary"
        cancel-title="Fechar"
        cancel-variant="secondary"
        @ok="addObs"
        :ok-disabled=disableSalvarObs()
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant">
        <template slot="modal-header">
          <h5>Nova Observação</h5>
        </template>
        <div>
          <label class="left labelSelect">Tipo de observação</label>
          <model-list-select
            :list="dadosTabela.tiposObservacoes"
            v-model="observacao.tipoObservacao"
            option-value="codigo"
            option-text="descricao"
            :isDisabled="!novaObservacao"
            placeholder="Selecione ou digite para pesquisar">
          </model-list-select>
        </div>
        <b-form-textarea
          class="mt-3"
          id="textarea"
          v-model="observacao.observacao"
          placeholder="Digite o conteúdo da observação..."
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-modal>
      <!--- FIM MODAL DE OBSERVACAO --->
      <!--- MODAL CANCELAMENTO --->
      <b-modal id="modal-scoped"
        v-model="modalConfirmaCancelamento"
        ok-title="Enviar"
        ok-variant="primary"
        cancel-title="Cancelar"
        cancel-variant="secondary"
        @ok="fechaModalCancelamento"
        :ok-disabled=disableEnviarCancelamento()
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant">
        <template slot="modal-header">
          <h5>Tem certeza que deseja cancelar este pedido?</h5>
        </template>
        <div>
          <label class="left labelSelect">Por favor, justifique o cancelamento deste pedido</label>
          <b-form-textarea
            class="mt-3"
            id="textarea"
            v-model="textoMotivoCancelamento"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </div>
      </b-modal>
      <!--- FIM MODAL CANCELAMENTO --->
      <b-modal
        title="Escolha um item"
        v-model="modalItens"
        :header-text-variant="headerTextVariant"
        :header-bg-variant="headerBgVariant"
        size="lg"
        hide-footer>
        <div>
          <b-input-group>
            <b-form-input size="sm" placeholder="Pesquisar por descrição, cor, tamanho..." v-model="pesquisa.termo" autocomplete="off" @focus="limpaPesq()"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text" autocomplete="no" v-on:click="pesquisarGrades()"><i class="fa fa-search"></i></span>
            </b-input-group-prepend>
          </b-input-group>
        </div>
        <div class="mt-3 table" v-if="grades.length > 0">
          <b-table bordered striped small :fields="fieldsGrades" :items="grades" class="mt-0">
            <template slot="urlImagemGrade" slot-scope="row">
            <img src="@/assets/sem-imagem.png" alt="" v-if="row.item.urlImagemGrade === ''">
            <img :src="row.item.urlImagemGrade" alt="" v-else>
          </template>
            <template slot="actions" slot-scope="row">
              <b-button size="sm" @click="buscarProdutosGrade(row.item)" class="mr-1">
                Selecionar
              </b-button>
            </template>
          </b-table>
        </div>
      </b-modal>
      <!--- MODAL DE IMPRESSAO --->
      <b-modal id="modal-scoped"
        size="xl"
        v-model="modalImpressao"
        ok-title="Imprimir"
        ok-variant="primary"
        cancel-title="Fechar"
        cancel-variant="secondary"
        @ok="imprimirPDF"
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant">
        <template slot="modal-header">
          <h5>Visualizar Impressão</h5>
        </template>
        <div id="impressaoPedido" v-html="htmlImpressao"></div>
      </b-modal>
      <!--- FIM MODAL DE IMPRESSAP --->
      <!--- MODAL DE CONFIRMAÇÃO DE REPRESENTANTE --->
      <b-modal
        @ok="salvarPedido()"
        @cancel="mostraRepNatIvo"
        ok-title="Sim"
        ok-variant="primary"
        cancel-title="Não"
        size="md"
        title="Confirmação"
        v-model="modalConfirmaRepLog"
        centered>
        Você realmente deseja inserir essa venda para o(a) representante <b>{{pedido.representante.apelido}}</b>?
        <!--{{pedido}}-->
      </b-modal>
      <!--- FIM DO MODAL DE CONFIRMAÇÃO DE REPRESENTANTE --->
      <!--- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE ITEM --->
      <b-modal
        @ok="removerItem(excluirItem)"
        ok-title="Sim"
        ok-variant="primary"
        cancel-title="Não"
        size="sm"
        title="Excluir Item"
        v-model="modalExclusao"
        centered>
        Você tem certeza que deseja excluir este item do pedido?
        <!--{{pedido}}-->
      </b-modal>
      <!--- FIM DO MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE ITEM --->
      <!--- MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE OBSERVACAO --->
      <b-modal
        @ok="removerObs(excluirObs)"
        ok-title="Sim"
        ok-variant="primary"
        cancel-title="Não"
        size="sm"
        title="Excluir Observação"
        v-model="modalExclusaoObs"
        centered>
        Você tem certeza que deseja excluir esta observação do pedido?
        <!--{{pedido}}-->
      </b-modal>
      <!--- FIM DO MODAL DE CONFIRMAÇÃO DE EXCLUSÃO DE OBSERVACAO --->
      <modal-add-itens-vue  v-show="isModalItensVisible" :pedidoSelecionado="pedido"  @close="closeModal"></modal-add-itens-vue>
      <!-- MODAL CLIENTE INDUSTRIAL -->
      <b-modal
        title="Pesquise um cliente"
        v-model="modalClienteInd"
        :header-text-variant="headerTextVariant"
        :header-bg-variant="headerBgVariant"
        size="lg"
        hide-footer>
        <div>
          <b-input-group>
            <b-form-input size="sm" placeholder="Cód. Cliente, Fantasia, Razão, CNPJ e Endereço" v-model="pesquisaClienteInd.termo" autocomplete="no"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text" v-on:click="pesquisarClienteInd()"><i class="fa fa-search"></i></span>
            </b-input-group-prepend>
          </b-input-group>
        </div>
        <div class="mt-3 table"  v-if="clientesPesquisados.length > 0">
          <b-table bordered striped small :fields="fieldsClientesInd" :items="clientesPesquisados" class="mt-0">
             <template slot="actions" slot-scope="row">
              <b-button size="sm" class="mr-1" @click="selecionarClienteInd(row.item)">
                Selecionar
              </b-button>
            </template>
          </b-table>
        </div>
      </b-modal>
      <!-- FIM MODAL CLIENTE INDUSTRIAL -->
      <!-- MODAL CONFIRMACAO DE SAIDA DE PAGINA -->
      <b-modal
        v-model="modalVoltarConfirma"
        ok-title="Sim"
        ok-variant="primary"
        cancel-title="Não"
        @ok="pageLista"
        :no-close-on-esc=true
        :no-close-on-backdrop=true
        :header-bg-variant="headerBgVariant"
        :header-text-variant="headerTextVariant">
        <template slot="modal-header">
          <h5>Sair sem Salvar</h5>
        </template>
        <span>Tem certeza que deseja sair sem salvar as alterações deste pedido?</span>
      </b-modal>
      <!-- FIM MODAL CONFIRMACAO DE SAIDA DE PAGINA -->
      <!-- MODAIS --->
      <BlockUI v-if="blockUiVisibility" :message="msgBlockUi">
        <spinner-vue  id="modal-xl" ></spinner-vue>
      </BlockUI>
      <toast-vue :idToast="idToast" :variant="variant" :titleMsg="titleMsg" :message="message"></toast-vue>
      <!-- <impressao-pedido-vue></impressao-pedido-vue> -->
    </div>
  </div>
</template>
<script>
  import dashboard from '@/services/dashboard'
  import { mapState } from 'vuex'
  import { broadcastServer } from '@/main'
  import { ModelListSelect } from 'vue-search-select'
  import pedidosServices from '@/services/tablePedidos'
  import produtoServices from '@/services/produto'
  import clienteServices from '@/services/tableClientes'
  import spinnerVue from '@/components/items/SpinnerVue'
  import modalAddItensVue from '@/components/items/modalAddItensVue'
  import impressaoPedidoVue from '@/components/items/impressaoPedidoVue'
  import ToastVue from '../layouts/toastVue'
  import { TheMask, mask } from 'vue-the-mask'
  import {VMoney} from 'v-money'

  export default {
    // props: ['title', 'header', 'clienteSelecionado'],
    directives: {
      mask,
      money: VMoney
    },
    data () {
      return {
        tipoClienteJuridico: false,
        dadosPedidoOriginal: {},
        modalVoltarConfirma: false,
        clienteIndustrializadorNome: '',
        cor: '',
        corSelec: '',
        idToast: 'my-toast-novoPedido',
        titleMsg: '',
        message: '',
        variant: '',
        htmlImpressao: null,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          precision: 2,
          masked: false
        },
        desabilitaSelectRepresentante: true,
        inserirItemPedido: {},
        isModalItensVisible: false,
        blockUiVisibility: false,
        visibility: {
          desconto: false
        },
        msgBlockUi: '',
        key: '',
        cidade: '',
        text: '',
        tiposObservacoes: null,
        options: [],
        textoMotivoCancelamento: '',
        headerTextVariant: 'light',
        headerBgVariant: 'dark',
        modalObs: false,
        modalConfirmaCancelamento: false,
        modalItens: false,
        modalImpressao: false,
        modalConfirmaRepLog: false,
        modalExclusao: false,
        modalExclusaoObs: false,
        modalClienteInd: false,
        dashboard: [],
        grades: [],
        clientes: [],
        btnSalvar: true,
        pesquisaClienteInd: {
          termo: '',
          uf: '',
          cidade: ''
        },
        pesquisa: {},
        desconto: {
          percentual: 0.00,
          valor: 0.00
        },
        excluirItem: '',
        excluirObs: '',
        status: [{
          idStatus: 1,
          codigo: '001',
          ordem: 1,
          chaveErp: '001',
          descricao: 'Orçamento',
          classe: 'col-md-4'
        }],
        fieldsGrades: [
          {
            key: 'urlImagemGrade',
            label: 'Imagem',
            sortable: false,
            tdClass: 'imgTable'
          },
          {
            key: 'codigoGrade',
            label: 'Item',
            sortable: true,
            class: 'txtLeft vertical'
          },
          {
            key: 'descricaoGrade',
            label: 'Descrição',
            sortable: true,
            class: 'txtLeft vertical'
          },
          {
            key: 'actions',
            label: '',
            class: 'txtCenter vertical'
          }
        ],
        fieldsClientesInd: [
          {
            key: 'cnpjCpf',
            label: 'CNPJ/CPF',
            sortable: true,
            formatter: this.formatterCnpjCpf
          },
          {
            key: 'fantasia',
            label: 'Nome Fantasia',
            sortable: true
          },
          {
            key: 'razaoSocial',
            label: 'Razão Social',
            sortable: true
          },
          {
            key: 'actions',
            label: ''
          }
        ],
        hover: true,
        novaObservacao: false,
        indiceObservacaoSelecionada: -1,
        observacao: {
          tipoObservacao: {
            codigo: '',
            exibeImpressao: 0,
            descricao: ''
          },
          observacao: '',
          chaveErp: '',
          numeroPedido: ''
        },
        dadosTabela: {
          condPagtos: [],
          tabelasPreco: [],
          representante: [],
          fretes: [],
          transportadoras: [],
          formaPagtos: [],
          tiposObservacoes: []
        },
        itemCondPagto: {
          codigo: '',
          faixaFinal: 0.00,
          faixaInicial: 0.00,
          descricao: ''
        },
        itemTabelaPreco: {
          codigo: '',
          tipoFrete: '',
          calculaImpostos: 0,
          descricao: ''
        },
        itemRepresentante: {
          codigo: '',
          apelido: ''
        },
        itemFretes: {
          codigo: '',
          descricao: ''
        },
        itemTransportadoras: {
          codigo: '',
          descricao: ''
        },
        itemFormaPagtos: {
          codigo: '',
          descricao: ''
        },
        clientesPesquisados: [],
        pedido: {
          chavePedido: 0,
          numeroPedido: '',
          numeroOrcamento: '',
          id: 0,
          statusGoSales: 2,
          isErp: false,
          isEditavel: true,
          chaveErp: '',
          motivoCancelamento: '',
          cliente: {},
          tabelaPreco: {},
          formaPagto: {},
          condPagto: {},
          tipoFrete: {},
          transportadora: {},
          representante: {},
          observacoes: [],
          itens: [],
          // totais: {}
          totais: {
            valorDesconto: 0.00,
            valorIPI: 0.00,
            valorICMSST: 0.00,
            valorTotal: 0.00
          }
        },
        counter: 0,
        empresaKatec: false,
        empresaAsiatex: false,
        empresaMaioricasa: false,
        percLimiteDescontoRepresentante: 0.00,
        dadosAcesso: '',
        descontoValor: 0,
        habilitaDescGeral: false
      }
    },
    props: {
      header: '',
      title: '',
      clienteSelecionado: {}
    },
    watch: {
      clienteSelecionado: function (newVal, oldVal) { // watch it
        // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.pedido.cliente = newVal // this.clienteSelecionado
        this.dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'))
        // let repLogado = JSON.parse(localStorage.getItem('representantesLogin'))
        if (this.dadosAcesso.perfil.id === 3) {
          this.pedido.representante = {codigo: this.dadosAcesso.representante.codigo, apelido: this.dadosAcesso.representante.apelido}
        }
        // let repSelecionado = localStorage.getItem('representanteSelecionado')
      }
    },
    components: {
      ModelListSelect,
      spinnerVue,
      modalAddItensVue,
      ToastVue,
      TheMask,
      impressaoPedidoVue
    },
    computed: {
      ...mapState({
        cor2: state => {
          const {cor2} = state.cor
          return {
            'background-color': cor2
          }
        },
        corSelecionado2: state => {
          const {corSelecionado2} = state.cor
          return {
            'background-color': corSelecionado2
          }
        }
      })
    },
    created: function () {
      this.dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'))
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      this.corSelec = {'background-color': `#${localStorage.getItem('corSelecionado')}`}
      let empresa = localStorage.getItem('empresaLogada')
      if (JSON.parse(empresa).identificador === 2355480534) {
        this.empresaKatec = true
      }
      if (JSON.parse(empresa).identificador === 224262964110) {
        this.empresaAsiatex = true
      }
      if (JSON.parse(empresa).identificador === 67365910546) {
        this.empresaMaioricasa = true
      }
      this.novoPedido()
      broadcastServer.$on('pedidoSelecionado', objPedido => {
        window.scrollTo(0, 0)
        this.refreshPedido(objPedido.pedido, objPedido.condPagtos)
        if (this.pedido.cliente.cnpjCpf.length >= 14) {
          this.tipoClienteJuridico = true
        } else {
          this.tipoClienteJuridico = false
        }
        this.pedido.cliente.cnpjCpf = this.formataCNPJCPF(this.pedido.cliente.cnpjCpf)
        this.dadosPedidoOriginal = Object.assign({}, this.pedido)
        if (this.pedido.isErp) {
          this.status = [{
            idStatus: 0,
            codigo: this.pedido.status.codigo,
            ordem: this.pedido.status.ordem,
            chaveErp: this.pedido.status.chaveErp,
            descricao: this.pedido.status.descricao,
            classe: 'col-md-12'
          }]
        } else {
          if (this.pedido.isEditavel) {
            this.novoStatus()
          } else {
            this.status = [{
              idStatus: this.pedido.status.idStatus,
              codigo: this.pedido.status.codigo,
              ordem: this.pedido.status.ordem,
              chaveErp: this.pedido.status.chaveErp,
              descricao: this.pedido.status.descricao,
              classe: 'col-md-12'
            }]
          }
        }
        pedidosServices.selecionar().then(response => {
          this.dadosTabela = response.data
          if (this.empresaAsiatex) {
            if (this.pedido.totais.valorTotal <= 1500) {
              this.pedido.tipoFrete = {
                'codigo': '002',
                'descricao': 'FOB'
              }
              this.dadosTabela.fretes = [{
                'codigo': '002',
                'descricao': 'FOB'
              }]
            }
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'pedidoSelecionado selecionar erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      })
      broadcastServer.$on('clienteSelecionado', objPedido => {
        window.scrollTo(0, 0)
        // this.refreshPedido(objPedido.pedido, objPedido.condPagtos)
        this.novoPedido()
        this.pedido.cliente = objPedido
        if (this.pedido.cliente.cnpjCpf.length >= 14) {
          this.tipoClienteJuridico = true
        } else {
          this.tipoClienteJuridico = false
        }
        this.pedido.cliente.cnpjCpf = this.formataCNPJCPF(this.pedido.cliente.cnpjCpf)
        if (this.dadosAcesso.perfil.id === 3) {
          this.pedido.representante = {codigo: this.dadosAcesso.representante.codigo, apelido: this.dadosAcesso.representante.apelido}
        }
        pedidosServices.selecionar().then(response => {
          this.dadosTabela = response.data
          if (this.empresaAsiatex) {
            if (this.pedido.totais.valorTotal <= 1500) {
              this.pedido.tipoFrete = {
                'codigo': '002',
                'descricao': 'FOB'
              }
              this.dadosTabela.fretes = [{
                'codigo': '002',
                'descricao': 'FOB'
              }]
            }
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'clienteSelecionado selecionar erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      })
      broadcastServer.$on('refreshPedido', objPedido => {
        this.refreshPedido(objPedido.pedido, objPedido.condPagtos)
        pedidosServices.selecionar().then(response => {
          this.dadosTabela = response.data
          if (this.empresaAsiatex) {
            if (this.pedido.totais.valorTotal <= 1500) {
              this.pedido.tipoFrete = {
                'codigo': '002',
                'descricao': 'FOB'
              }
              this.dadosTabela.fretes = [{
                'codigo': '002',
                'descricao': 'FOB'
              }]
            }
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'refreshPedido selecionar erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      })
      broadcastServer.$on('adicionarPedido', pedido => {
        window.scrollTo(0, 0)
        this.novoPedido()
        pedidosServices.selecionar().then(response => {
          this.dadosTabela = response.data
          if (this.empresaAsiatex) {
            if (this.pedido.totais.valorTotal <= 1500) {
              this.pedido.tipoFrete = {
                'codigo': '002',
                'descricao': 'FOB'
              }
              this.dadosTabela.fretes = [{
                'codigo': '002',
                'descricao': 'FOB'
              }]
            }
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'adicionarPedido selecionar erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      })
      broadcastServer.$on('fechaModalItens', param => {
        this.modalItens = false
      })
      this.msgBlockUi = 'Listando itens, aguarde...'
      this.blockUiVisibility = true
      pedidosServices.selecionar().then(response => {
        this.dadosTabela = response.data
        if (this.empresaAsiatex) {
          if (this.pedido.totais.valorTotal <= 1500) {
            this.pedido.tipoFrete = {
              'codigo': '002',
              'descricao': 'FOB'
            }
            this.dadosTabela.fretes = [{
              'codigo': '002',
              'descricao': 'FOB'
            }]
          }
        }
      }).catch(error => {
        console.log(error)
        this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'created selecionar erro')
      }).finally(() => {
        this.blockUiVisibility = false
      })
    },
    mounted () {
      this.novoPedido()
      dashboard.listarDashboard().then(response => {
        this.dashboard = response.data.duplicatas
      })
      this.dadosAcesso = JSON.parse(localStorage.getItem('dadosAcesso'))
      this.percLimiteDescontoRepresentante = this.dadosAcesso.representante.percLimiteDesconto
    },
    methods: {
      descTabela: function (item) {
        return `${item.codigo} - ${item.descricao}`
      },
      descRepresentante: function (item) {
        return `${item.codigo} - ${item.apelido}`
      },
      mostraRepNatIvo () {
        console.log(this.pedido)
      },
      imprimirPedido: function (telaImpressao) {
        telaImpressao = window.open('about:blank')
        let html = ''
        html += '<html>'
        html += '<head>'
        html += '<style>'
        html += '.txtRight {text-align: right}'
        html += '.md {margin-left: 15%}'
        html += '.md1 {margin-left: 25%}'
        html += '.md2 {margin-left: 35%}'
        html += '.md3 {margin-left: 45%}'
        html += '.md4 {margin-left: 50%}'
        html += '.md5 {margin-left: 65%}'
        html += '.line {margin-top: 1px solid black}'
        html += '.mt {margin-top: 30%}'
        html += '</style>'
        html += '</head>'
        html += '<body>'
        // inicio body
        html += '<h1>testando</h1>'
        html += '<div id="impressaoPedido">'
        html += '<div class="txtRight">'
        html += '<p><b>Grupo|GC</b></p>'
        html += '<p><b>Contanto: </b></p>'
        html += '<p>site</p>'
        html += '</div>'
        html += '<div class="txtLeft">'
        html += '<b>Endereço: </b>'
        html += '</div>'
        html += '<h3 class="txtLeft mt-3">Detalhes do Cliente</h3>'
        html += '<hr>'
        html += '<div class="txtLeft">'
        html += '<span><b>Cliente: </b></span><span class="md4"><b>Contato: </b></span><br>'
        html += '<span><b>Fantasia: </b></span><span class="md4"><b>CNPJ: </b></span><br>'
        html += '<hr>'
        html += '<h3 class="txtLeft mt-3">Detalhes do Pedido</h3>'
        html += '<hr>'
        html += '<span><b>Representante: </b></span><span class="md2"><b>Pedido: </b></span><span class="md"><b>Data Emissão: </b></span><br>'
        html += '<span><b>Tipo Frete: </b></span><span class="md"><b> Transp.: </b></span><br>'
        html += '<span><b>Condição de Pagamento: </b></span><span class="md1"><b>Forma de Pagamento: </b></span><br>'
        html += '<h3 class="txtLeft mt-3">Totais</h3>'
        html += '<hr>'
        html += '<span>categoria</span><span class="md3">R$ </span><br>'
        html += '<span><b>Total</b></span><span style="margin-left: 48.5%"><b>R$</b></span>'
        html += '<h3 class="txtLeft mt-3">Observações</h3>'
        html += '<hr>'
        html += '<span>Tipo obs</span><span class="md">obs</span>'
        html += '<span class="mt line"><p>Representante</p></span><span class="mt line"><p>Cliente</p></span>'
       // fim body
        html += '</body>'
        html += '</html>'
        telaImpressao.document.write(html)
        telaImpressao.document.close()// FECHA A JANELA
        telaImpressao.print()
      },
      formataTelefone: function (telefone) {
        telefone.replace('-', '').replace('-', '')
        if (telefone.length === 8) {
          return telefone.substring(0, 4) + '-' + telefone.substring(4, 8)
        } else if (telefone.length === 9) {
          return telefone.substring(0, 5) + '-' + telefone.substring(5, 9)
        } else {
          return telefone
        }
      },
      retornaEnderecoEmpresa: function (empresa) {
        let cep = empresa.cep.substring(0, 5) + '-' + empresa.cep.substring(5, 8)
        return empresa.endereco + ', ' + empresa.numero + ' - CEP: ' + cep + ' - ' + empresa.bairro + ' - ' + empresa.cidade + ' - ' + empresa.uf
      },
      retornaContatoEmpresa: function (empresaLogada) {
        if (typeof empresaLogada.telefone !== 'undefined') {
          let telFormatado = this.formataTelefone(empresaLogada.telefone)
          return '(' + empresaLogada.ddd + ') ' + telFormatado
        } else {
          return 'Não Cadastrado'
        }
      },
      retornaContatoCliente: function (cliente) {
        if (typeof cliente.telefone !== 'undefined') {
          return cliente.ddd + ' ' + cliente.telefone
        } else {
          return 'Não Cadastrado'
        }
      },
      retornaEnderecoCliente: function (enderecoCliente) {
        if (typeof enderecoCliente !== 'undefined') {
          if (enderecoCliente.codTipo) {
            let cep = enderecoCliente.cep.substring(0, 5) + '-' + enderecoCliente.cep.substring(5, 8)
            return enderecoCliente.endereco + ', ' + enderecoCliente.numero + ' - CEP: ' + cep + ' - ' + enderecoCliente.bairro + ' - ' + enderecoCliente.cidade + ' - ' + enderecoCliente.uf
          } else {
            return 'Não Cadastrado'
          }
        } else {
          return 'Não Cadastrado'
        }
      },
      formataCNPJCPF: function (cnpjCpf) {
        cnpjCpf = cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '')
        if (cnpjCpf.length === 11) {
          return cnpjCpf.substring(0, 3) + '.' + cnpjCpf.substring(3, 6) + '.' + cnpjCpf.substring(6, 9) + '-' + cnpjCpf.substring(9, 11)
        } else if (cnpjCpf.length === 14) {
          return cnpjCpf.substring(0, 2) + '.' + cnpjCpf.substring(2, 5) + '.' + cnpjCpf.substring(5, 8) + '/' + cnpjCpf.substring(8, 12) + '-' + cnpjCpf.substring(12, 14)
        } else {
          return cnpjCpf
        }
      },
      limpaFormataCNPJCPF: function (cnpjCpf) {
        cnpjCpf = cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '')
        if (cnpjCpf.length === 11) {
          return cnpjCpf.substring(0, 3) + '.' + cnpjCpf.substring(3, 6) + '.' + cnpjCpf.substring(6, 9) + '-' + cnpjCpf.substring(9, 11)
        } else if (cnpjCpf.length === 14) {
          return cnpjCpf.substring(0, 2) + '.' + cnpjCpf.substring(2, 5) + '.' + cnpjCpf.substring(5, 8) + '/' + cnpjCpf.substring(8, 12) + '-' + cnpjCpf.substring(12, 14)
        } else {
          return cnpjCpf
        }
      },
      retornaHtmlCabecalhoItem: function (temDesconto) {
        let cabecalhoItem = ''
        if (temDesconto) {
          cabecalhoItem += '<div class="divTableRow">'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Produto</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Imagem</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:22%;height:10px;vertical-align: middle;text-align: center;">Descrição</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Preço Tab.</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Desconto</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Prc.Unit</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Qtde.</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Vlr.IPI</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:08%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">ICMS-ST</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Tot.Item</div>'
          cabecalhoItem += '</div>'
        } else {
          cabecalhoItem += '<div class="divTableRow">'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Produto</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;">Imagem</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:38%;height:10px;vertical-align: middle;text-align: center;">Descrição</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Prc.Unit</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Qtde.</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Vlr.IPI</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">ICMS-ST</div>'
          cabecalhoItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 7 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">Tot.Item</div>'
          cabecalhoItem += '</div>'
        }
        return cabecalhoItem
      },
      retornaHtmlItem: function (item, temDesconto) {
        let htmlItem = ''
        let imgContent = ''
        if (item.url === '' || item.url === null) {
          imgContent = '<img style="max-width: 100%; max-height: 100%; vertical-align: middle; text-align: center;" src="/static/img/sem-imagem.44e3842.png"/>'
        } else {
          imgContent = '<img style="max-width: 100%; max-height: 100%; vertical-align: middle; text-align: center;" src="' + item.url + '"/>'
        }
        let descProduto = item.descricao
        if (item.vendaSobMedidaM2 === 1) {
          descProduto += 'Larg.: ' + this.formatterValue(item.largura) + ' - Comp.: ' + this.formatterValue(item.comprimento)
        }
        if (temDesconto) {
          htmlItem += '<div class="divTableRow">'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle;text-align: center;font-family: Source Sans Pro-Regular; font-size: small; padding: 4px; width: 10%;height:40px;">' + item.codProduto + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align:center; width:15%; height:80px;">' + imgContent + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; font-family: Source Sans Pro Regular;font-size: small; width: 38%; padding-left:5px;height:80px;height:40px;">' + descProduto + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorTabela) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.percDesconto) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorUnitario) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.qtdVenda) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorIPI) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorICMSST) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 10%;height:40px;padding-right:2px">' + this.formatterValue(item.totalItem) + '</div>'
          htmlItem += '</div>'
        } else {
          htmlItem += '<div class="divTableRow">'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: center;font-family: Source Sans Pro-Regular; font-size: small; padding: 4px; width: 10%;height:40px;">' + item.codProduto + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align:center; width:15%; height:80px;">' + imgContent + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; font-family: Source Sans Pro Regular;font-size: small;width: 38%; padding-left:5px;height:80px;height:40px;">' + descProduto + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorUnitario) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.qtdVenda) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorIPI) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 8%;height:40px;padding-right:2px;">' + this.formatterValue(item.valorICMSST) + '</div>'
          htmlItem += '    <div class="divTableCell" style="vertical-align: middle; text-align: right;font-family: Source Sans Pro-Regular; font-size: small;width: 10%;height:40px;padding-right:2px">' + this.formatterValue(item.totalItem) + '</div>'
          htmlItem += '</div>'
        }
        return htmlItem
      },
      retornaHtmlItemPedidoTotal: function (temDesconto, somaQtdePedido, somaTotalPedido) {
        let totalItem = ''
        if (temDesconto) {
          totalItem += '<div class="divTableRow">'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px; width:10%;height:10px;vertical-align: middle;text-align: center;">Total</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:10%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:22%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">' + this.formatterValue(somaQtdePedido) + '</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000;width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px">' + this.formatterValue(somaTotalPedido) + '</div>'
          totalItem += '</div>'
        } else {
          totalItem += '<div class="divTableRow">'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px; width:10%;height:10px;vertical-align: middle;text-align: center;">Total</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:10%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; padding: 4px;width:38%;height:10px;vertical-align: middle;text-align: center;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">' + this.formatterValue(somaQtdePedido) + '</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000; width:8%;height:10px;vertical-align: middle;text-align: center;padding-right:2px;">&nbsp;</div>'
          totalItem += '    <div class="divTableCell" style="font-family: Source Sans Pro 9 SemiBold;font-size: small;color: #FFFFFF; background-color: #000000;width:10%;height:10px;vertical-align: middle;text-align: center;padding-right:2px">' + this.formatterValue(somaTotalPedido) + '</div>'
          totalItem += '</div>'
        }
        return totalItem
      },
      retornaTotaisPorCategoria: function () {
        let categorias = []
        let itens = this.pedido.itens.sort(function (a, b) {
          return a.ordemCategoria - b.ordemCategoria || a.descricao - b.descricao
        })
        for (var i = 0; i < itens.length; i++) {
          let item = itens[i]
          if (categorias.length === 0) {
            categorias.push({codigo: item.codigoCategoria, descricao: item.descricaoCategoria, ordem: item.ordemCategoria, valor: 0.00})
          } else {
            let categoriaNoArray = categorias.filter(cat => cat.codigo === item.codigoCategoria)
            if (categoriaNoArray.length === 0) {
              categorias.push({codigo: item.codigoCategoria, descricao: item.descricaoCategoria, ordem: item.ordemCategoria, valor: 0.00})
            }
          }
        }
        let somaTotaisCategorias = 0
        for (var ii = 0; ii < categorias.length; ii++) {
          let categoria = categorias[ii]
          let itensPedidosDaCategoria = itens.filter(item => item.codigoCategoria === categoria.codigo)
          let totalCategoria = itensPedidosDaCategoria.reduce(function (r, a) { return r + ((a.qtdVenda * a.valorTabela) + a.valorIPI + a.valorICMSST) }, 0)
          categorias[ii].valor = totalCategoria
          somaTotaisCategorias += totalCategoria
        }
        categorias = categorias.sort(function (a, b) {
          return a.ordem - b.ordem
        })
        let htmlCategorias = ''
        for (var iii = 0; iii < categorias.length; iii++) {
          let categoria = categorias[iii]
          htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">'
          htmlCategorias += '<td style="width: 80%;padding: 2px;width: 50%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>' + categoria.descricao + '</b></td><td style="width: 20%;padding: 2px; width: 50%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>' + this.formatterValue(categoria.valor) + '</b></td></tr>'
        }
        let totalDesconto = itens.reduce(function (r, a) { return r + a.valorDesconto }, 0)
        if (totalDesconto > 0) {
          // SUBTOTAL
          htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">'
          htmlCategorias += '<td style="width: 80%;padding: 2px;width: 50%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>SubTotal</b></td><td style="width: 20%;padding: 2px; width: 50%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>' + this.formatterValue(somaTotaisCategorias) + '</b></td></tr>'
          // DESCONTO
          htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">'
          htmlCategorias += '<td style="width: 80%;padding: 2px;width: 50%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>Desconto</b></td><td style="width: 20%;padding: 2px; width: 50%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>' + this.formatterValue(totalDesconto) + '</b></td></tr>'
        }
        if (htmlCategorias !== '') {
          let total = (somaTotaisCategorias - totalDesconto) // categorias.reduce(function (r, a) { return r + a.valor }, 0)
          htmlCategorias += '<tr style="border-bottom: 2px solid white;background-color: #D8D8D8;">'
          htmlCategorias += '<td style="width: 80%;text-align: left;font-family: Source Sans Pro 16 ;font-size: small;">'
          htmlCategorias += '<b>Total</b></td><td style="width: 20%;text-align: right;padding-right: 2px;font-family: Source Sans Pro 16 ;font-size: small;"><b>' + this.formatterValue(total) + '</b></td></tr>'
        }
        return htmlCategorias
      },
      retornaHtmlItensPedido: function () {
        let temDesconto = false
        let arrayPaginas = []
        let itens = this.pedido.itens.sort(function (a, b) {
          return a.ordemCategoria - b.ordemCategoria || a.descricao - b.descricao
        })
        for (var i = 0; i < itens.length; i++) {
          let item = this.pedido.itens[i]
          if (item.percDesconto > 0) {
            temDesconto = true
            break
          }
        }
        for (var ii = 0; ii < this.pedido.itens.length; ii++) {
          let item = this.pedido.itens[ii]
          let htmlItem = this.retornaHtmlItem(item, temDesconto)
          arrayPaginas.push(htmlItem)
        }
        let somaQtdePedido = this.pedido.itens.reduce(function (r, a) { return r + a.qtdVenda }, 0)
        let somaTotalPedido = this.pedido.itens.reduce(function (r, a) { return r + a.totalItem }, 0)
        let htmlTotaisItensPedido = this.retornaHtmlItemPedidoTotal(temDesconto, somaQtdePedido, somaTotalPedido)
        arrayPaginas.push(htmlTotaisItensPedido)
        // inicia o processo de paginar os itens
        let agrupaPagina = ''
        var acumulaAgrupador = ''
        let entrou = false
        acumulaAgrupador += '<div style="page-break-inside: avoid;"></div><div style="page-break-inside: avoid; clear: both" />'
        for (var indiceArray = 0; indiceArray < arrayPaginas.length; indiceArray++) {
          let posicao = indiceArray + 1
          entrou = false
          agrupaPagina += arrayPaginas[indiceArray]
          if (posicao % 18 === 0) {
            let cabecalhoItem = this.retornaHtmlCabecalhoItem(temDesconto)
            // acumulaAgrupador += '<div style="page-break-before: always; clear: both"><div style="page-break-before: always">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-before: always; clear: both" />'
            acumulaAgrupador += '<div style="page-break-inside: avoid;">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-inside: avoid; clear: both" />'
            agrupaPagina = ''
            entrou = true
          }
        }
        if (!entrou) {
          let cabecalhoItem = this.retornaHtmlCabecalhoItem(temDesconto)
          // acumulaAgrupador += '<div style="page-break-before: always; clear: both"><div style="page-break-before: always">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-before: always; clear: both" />'
          acumulaAgrupador += '<div style="page-break-inside: avoid;">' + cabecalhoItem + agrupaPagina + '</div><div style="page-break-inside: avoid; clear: both;" />'
          agrupaPagina = ''
        }
        let tamAcumulaAgrupador = acumulaAgrupador.length
        // let tamCorta = '<div style="page-break-before: always; clear: both" />'.length
        let tamCorta = '<div style="page-break-inside: avoid; clear: both;" />'.length
        let corta = (tamAcumulaAgrupador - tamCorta)
        acumulaAgrupador = acumulaAgrupador.substring(0, corta)
        return acumulaAgrupador
      },
      imprimePedido2: function () { // telaImpressao
        if (this.pedido.itens.length === 0) {
          this.showMessage('Insira algum item no pedido antes de visualizar a impressão!', 'Alerta', 'danger', 'imprimePedido2')
        } else {
          let empresaLogada = JSON.parse(localStorage.getItem('empresaLogada'))
          console.log('empresa: ' + JSON.stringify(empresaLogada))
          console.log('pedido: ' + JSON.stringify(this.pedido))
          // telaImpressao = window.open('about:blank')
          let html = ''
          let LS_IDGOSALES = 'ID GoSales: #'
          let LS_IDPEDIDO = 'ID Pedido: #'
          let LS_IDORCAMENTO = 'ID Orçamento: #'
          let LS_STATUSPEDIDO = 'Status Pedido: '
          let IDGOSALES = this.pedido.id
          let IDPEDIDO = this.pedido.numeroPedido
          let IDORCAMENTO = this.pedido.numeroOrcamento
          let STATUSPEDIDO = this.pedido.status.descricao
          let LS_DATA_EMISSAO = 'Data Emissão: '
          let EMISSAO = this.pedido.emissao
          let NOME_EMPRESA = empresaLogada.nome
          let URL_LOGO_MARCA = empresaLogada.urlLogoNegativo
          let urlLogoEvento = ''
          let LOGO_EVENTO = ''
          let LS_CONTATO = 'Contato: '
          let CONTATO_EMPRESA = this.retornaContatoEmpresa(empresaLogada)
          let URL_SITE_MARCA = empresaLogada.site
          let LS_ENDERECO = 'Endereço: '
          let ENDERECOCLIENTE = this.retornaEnderecoCliente(this.pedido.cliente.endereco)
          let ENDERECO_EMPRESA = this.retornaEnderecoEmpresa(empresaLogada)
          let LS_DETALHE_CLIENTE = 'Detalhes do Cliente'
          let LS_CLIENTE = 'Cliente: '
          let RAZAOCLIENTE = this.pedido.cliente.razaoSocial
          let LS_FANTASIA = 'Fantasia: '
          let LS_CNPJ = ''
          let CNPJCLIENTE = this.limpaFormataCNPJCPF(this.pedido.cliente.cnpjCpf)
          let FANTASIACLIENTE = this.pedido.cliente.fantasia
          let CONTATOCOMERCIAL = this.retornaContatoCliente(this.pedido.cliente)
          let LS_REPRESENTANTE = 'Representante: '
          let VENDEDOR = this.pedido.representante.apelido
          let LS_DETALHE_PEDIDO = 'Detalhes do Pedido'
          let LS_TIPO_FRETE = 'Tipo De Frete: '
          let TIPOFRETE = (typeof this.pedido.tipoFrete.descricao === 'undefined' ? ' Não Selecionado' : this.pedido.tipoFrete.descricao)
          let LS_TRANSP = 'Transp.:'
          let TRANSPORTADORA = (typeof this.pedido.transportadora.nome === 'undefined' ? ' Não Informada' : this.pedido.transportadora.nome)
          let LS_CONDICAO_PAGTO = 'Condição de Pagamento: '
          let CONDICAO = (typeof this.pedido.condPagto.descricao === 'undefined' ? ' Não Informada' : this.pedido.condPagto.descricao)
          let LS_FORMA_PAGTO = 'Forma de Pagamento: '
          let FORMA = (typeof this.pedido.formaPagto.descricao === 'undefined' ? ' Não Informada' : this.pedido.formaPagto.descricao)
          let LS_TOTAIS = 'Totais'
          let TOTALIZADORES = this.retornaTotaisPorCategoria()
          let LS_NOTES = ''
          let OBSERVACOES = ''
          let LS_MOTIVO_CANCELAMENTO = ''
          let MOTIVO_CANCELAMENTO = ''
          let LS_REPRESENTANTE_ASSINATURA = 'Representante'
          let LS_CLIENTE_ASSINATURA = 'Cliente'
          let ITEMS_PEDIDO = this.retornaHtmlItensPedido()
          let URL_LOGO_GOSALESPRO = 'https://s3-sa-east-1.amazonaws.com/mustti-manager/go-sales-pro/logos/icon-gosalespro.png'
          if (urlLogoEvento !== '') {
            LOGO_EVENTO = '<img src="' + urlLogoEvento + '" style="width: 248px; height: 93px;" align="left">'
          }
          // observacoes
          if (this.pedido.observacoes.length > 0) {
            LS_NOTES = 'Observações'
            OBSERVACOES += '<tr>'
            OBSERVACOES += '<td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"></td>'
            OBSERVACOES += ' </tr>'
            for (var iObs = 0; iObs < this.pedido.observacoes.length; iObs++) {
              let observacao = this.pedido.observacoes[iObs]
              if (observacao.tipoObservacao.exibeImpressao === 1) {
                OBSERVACOES += '<tr style="border-bottom: 2px solid white; background-color: #D8D8D8;">'
                OBSERVACOES += '<td style="width: 20%;text-align: left; background-color: #D8D8D8; padding: 2px;">'
                OBSERVACOES += '<div style="padding: 2px;font-family: Source Sans Pro 10 ;font-size: small;"><b>' + observacao.tipoObservacao.descricao + '</b></div>'
                OBSERVACOES += '</td>'
                OBSERVACOES += '<td style="width: 80%;text-align: left; background-color: #ECECEC; padding: 2px;">'
                OBSERVACOES += '<div style="padding: 2px;font-family: Source Sans Pro 10 ;font-size: small;">' + observacao.observacao + '</div>'
                OBSERVACOES += '</td>'
                OBSERVACOES += '</tr>'
              }
            }
          }
          if (this.pedido.motivoCancelamento !== '') {
            LS_MOTIVO_CANCELAMENTO = 'Motivo do Cancelamento'
            MOTIVO_CANCELAMENTO += '<tr>'
            MOTIVO_CANCELAMENTO += '    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"><p>' + this.pedido.motivoCancelamento + '</p></td>'
            MOTIVO_CANCELAMENTO += '</tr>'
          }
          if (this.tipoClienteJuridico) {
            LS_CNPJ = 'CNPJ: '
          } else {
            LS_CNPJ = 'CPF: '
          }
          if (this.empresaKatec === true) {
            LS_FANTASIA = 'Cliente Reduzido: '
          }
          html += '<!DOCTYPE html>'
          html += '<html>'
          html += '    <head>'
          html += '        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">'
          html += '        <meta name="format-detection" content="telephone=no">'
          html += '        <style type="text/css" media="print,screen">'
          html += '            .divTable{'
          html += '                display: table;'
          html += '                width: 100%;'
          html += '            }'
          html += '            .divTableRow {'
          html += '                display: table-row;'
          html += '            }'
          html += '            .divTableHeading {'
          html += '                background-color: #EEE;'
          html += '                display: table-header-group;'
          html += '            }'
          html += '            .divTableCell, .divTableHead {'
          html += '                border: 0.5px solid #999999;'
          html += '                display: table-cell;'
          html += '            }'
          html += '            .divTableCellTotal  {'
          html += '                display: table-cell;'
          html += '                padding: 3px 10px;'
          html += '                background-color:#000000;'
          html += '                color: #FFFFFF;'
          html += '                font-weight: bold;'
          html += '                height:10px;'
          html += '            }'
          html += '            .divTableHeading {'
          html += '                background-color: #EEE;'
          html += '                display: table-header-group;'
          html += '                font-weight: bold;'
          html += '            }'
          html += '            .divTableFoot {'
          html += '                background-color: #EEE;'
          html += '                display: table-footer-group;'
          html += '                font-weight: bold;'
          html += '            }'
          html += '            .divTableBody {'
          html += '                display: table-row-group;'
          html += '            }'
          html += '            section {'
          html += '                padding: 0px 0px 50px;'
          html += '            }'
          html += '            footer {'
          html += '                position: relative;'
          html += '                bottom: 0;'
          html += '                width: 100%;'
          html += '                background: #ECECEC;'
          html += '                padding: 10px;'
          html += '            }'
          html += '            footer p {'
          html += '                margin: 0;'
          html += '                display: inline-block;'
          html += '                font-size: 15px;'
          html += '                text-align: center;'
          html += '                width: 100%;'
          html += '            }'
          html += '            footer img {'
          html += '                width: 32px;'
          html += '                position: absolute;'
          html += '                top: 7px;'
          html += '                right: 20px;'
          html += '            }'
          html += '            body {'
          html += '                overflow-y: scroll;'
          html += '                height: 600px;'
          html += '                position: relative;'
          html += '            }'
          html += '        </style>'
          html += '    </head>'
          // CABEÇALHO
          html += '    <body>'
          html += '        <table width="90%" align="center" border="0">'
          html += '            <tbody>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="text-align:center ; padding-bottom: 3px;">'
          html += '                        <br>'
          html += '                        <img  src=' + URL_LOGO_MARCA + ' style="max-width: 30%; max-height:60px;" align="center">'
          html += '                      </td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:right; font-family: Source Sans Pro 8 Bold;font-size: medium; background-color: #FFFFFF; padding: 15px">' + LOGO_EVENTO + '<b>' + NOME_EMPRESA + '</b><br><b>' + LS_CONTATO + '</b> ' + CONTATO_EMPRESA + '<br>' + URL_SITE_MARCA + '<br><b>' + LS_ENDERECO + '</b>' + ENDERECO_EMPRESA
          html += '                    </td>'
          html += '                </tr>'
          // DETALHES DO CLIENTE
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_DETALHE_CLIENTE + '</b></td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; padding: 0px;"><hr style="width: 100%;"></td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="5" style="width: 10%;text-align:left; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_CLIENTE + '</b>' + RAZAOCLIENTE + '</td>'
          html += '                    <td colspan="4" style="width: 33%;text-align:right; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_CONTATO + '</b>' + CONTATOCOMERCIAL + '</td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="5" style="width: 33%;text-align:left; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_FANTASIA + '</b>' + FANTASIACLIENTE + '</td>'
          html += '                    <td colspan="4" style="width: 10%;text-align:right; font-family: Source Sans Pro 6 ;font-size: small;"><b>' + LS_CNPJ + '</b>' + CNPJCLIENTE + '</td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 10%;text-align:left; font-family: Source Sans Pro 6 ; font-size: small;"><b>' + LS_ENDERECO + '</b>' + ENDERECOCLIENTE + '</td>'
          html += '                </tr>'
          html += '                <tr style="width:100%;height: 1px;">'
          html += '                    <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="width:10%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>'
          html += '                </tr>'
          // DETALHES DO PEDIDO
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_DETALHE_PEDIDO + '</b></td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"></td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="3" style="width: 30%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_STATUSPEDIDO + '</b>' + STATUSPEDIDO + '</td>'
          html += '                    <td colspan="2" style="width: 30%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_IDPEDIDO + '</b>' + IDPEDIDO + '</td>'
          html += '                    <td colspan="2" style="width: 30%;text-align:center; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_IDORCAMENTO + '</b>' + IDORCAMENTO + '</td>'
          html += '                    <td colspan="2" style="width: 30%;text-align:right; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_IDGOSALES + '</b>' + IDGOSALES + '</td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="6" style="width: 20%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_REPRESENTANTE + '</b> ' + VENDEDOR + '</td>'
          html += '                    <td colspan="3" style="width: 30%;text-align:right; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_DATA_EMISSAO + '</b>' + EMISSAO + '</td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="2" style="width: 10%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_TIPO_FRETE + '</b> ' + TIPOFRETE + '</td>'
          html += '                    <td colspan="7" style="width: 30%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_TRANSP + '</b>' + TRANSPORTADORA + '</td>'
          html += '                </tr>'
          html += '                <tr></tr>'
          html += '                <tr>'
          html += '                    <td colspan="4" style="width: 10%;text-align:left; font-family: Source Sans Pro 10 ;font-size: small;"><b>' + LS_CONDICAO_PAGTO + '</b> ' + CONDICAO + '</td>'
          html += '                    <td colspan="5" style="width: 30%;text-align:right; font-family: Source Sans Pro 16 ;font-size: small;"><b>' + LS_FORMA_PAGTO + '</b> ' + FORMA + '</td>'
          html += '                </tr>'
          html += '                <tr style="width:100%;height: 1px;">'
          html += '                    <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="width:10%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '                    <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>'
          html += '                </tr>'
          html += '            </tbody>'
          html += '        </table>'
          // TOTALIZADORES
          html += '        <table width="90%" align="center" style="border: 0.7px; solid white">'
          html += '            <tbody>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_TOTAIS + '</b></td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ; font-size: small;padding: 0px;"><hr style="width: 100%;"></td>'
          html += '                </tr>'
          html += '                ' + TOTALIZADORES + ''
          html += '            </tbody>'
          html += '        </table>'
          html += '        <tr style="width:100%;height: 1px;">'
          html += '            <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>'
          html += '            <td style="width:10%;height: 1px;">&nbsp;</td>'
          html += '            <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>'
          html += '        </tr>'
          // OBSERVACOES
          html += '        <table width="90%" align="center" style="border: 0.7px; solid white">'
          html += '            <tbody>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_NOTES + '</b></td>'
          html += '                </tr>'
          html += '                ' + OBSERVACOES + ''
          html += '            </tbody>'
          html += '        </table>'
          html += '        <tr style="width:100%;height: 1px;">'
          html += '            <td style="text-align: center;font-family: Source Sans Pro-Regular;font-size: small;width: 10%;height: 1px;">&nbsp;</td>'
          html += '            <td style="width:10%;height: 1px;">&nbsp;</td>'
          html += '            <td style="font-family: Source Sans Pro Regular;font-size: small;width: 32%; padding-left:5px;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;height: 1px;">&nbsp;</td>'
          html += '            <td style="text-align: right;font-family: Source Sans Pro-Regular;font-size: small;width: 8%;;height: 1px;">&nbsp;</td>'
          html += '        </tr>'
          // MOTIVO CANCELAMENTO
          html += '        <table width="90%" align="center" style="border: 0.7px; solid white">'
          html += '            <tbody>'
          html += '                <tr>'
          html += '                    <td colspan="9" style="width: 60%;text-align:left; font-family: Source Sans Pro 10 ;padding-bottom: 0px; padding-left: 5px; padding-top: 5px;"><b>' + LS_MOTIVO_CANCELAMENTO + '</b></td>'
          html += '                </tr>'
          html += '                ' + MOTIVO_CANCELAMENTO + ''
          html += '            </tbody>'
          html += '        </table>'
          // LINHAS EM BRANCO
          html += '        <br><br><br><br>'
          // ASSINATURA
          html += '        <table width="90%" align="center">'
          html += '            <tbody>'
          html += '                <tr>'
          html += '                    <td style="width:20%; border-top:1px solid black;text-align:left;"></td>'
          html += '                    <td style="width:20%; border-top:1px solid black;text-align:right;"></td>'
          html += '                </tr>'
          html += '                <tr>'
          html += '                    <td style="width:50%;text-align:center;font-family: Source Sans Pro 16 ;font-size: small;">' + LS_REPRESENTANTE_ASSINATURA + '</td>'
          html += '                    <td style="width:50%;text-align:center;font-family: Source Sans Pro 16 ;font-size: small;">' + LS_CLIENTE_ASSINATURA + '</td>'
          html += '                </tr>'
          html += '            </tbody>'
          html += '        </table>'
          html += '        <br>'
          // LOGO GOSALES
          html += '        <div class="divTable" style="width:90%; margin-left:auto; margin-right:auto;">'
          html += '            <div class="divTableBody">'
          html += '                ' + ITEMS_PEDIDO + ''
          html += '            </div>'
          html += '        </div>'
          html += '        <section>'
          html += '            <br>'
          html += '            <footer>'
          html += '                <p>Desenvolvido por Mustti - GoSales Pro</p>'
          html += '                <img src="' + URL_LOGO_GOSALESPRO + '" />'
          html += '            </footer>'
          html += '        </section>'
          html += '    </body>'
          html += '</html>'
          this.htmlImpressao = html
          this.modalImpressao = true
        }
      },
      imprimirPDF: function () {
        // let sourceHtml = document.getElementById('impressaoPedido') // document.getElementsByTagName('body')[0]
        // var opt = {
        //   margin: 0,
        //   filename: 'myfile.pdf',
        //   image: {type: 'jpeg', quality: 0.98},
        //   html2canvas: {scale: 2, useCORS: true},
        //   jsPDF: {
        //     unit: 'mm',
        //     format: 'a4', // [280, 350],
        //     orientation: 'portrait'
        //   }
        // }
        // html2pdf().set(opt).from(this.htmlImpressao).save()
        // var printDoc = new JsPDF()
        // printDoc.fromHTML(sourceHtml, 10, 10, {'width': 180})
        // var specialElementHandlers = {}
        // var margins = {
        //   top: 10,
        //   bottom: 60,
        //   left: 10
        // }
        // printDoc.fromHTML(sourceHtml, margins.left, margins.top, {'width': 100, 'elementHandlers': specialElementHandlers}, function (dispose) {
        //   printDoc.save('test.pdf')
        // }, margins)
        // printDoc.fromHTML(sourceHtml.html())
        // *printDoc.autoPrint()
        // *printDoc.output('dataurlnewwindow')
        // let div = document.body.getElementById('impressaoPedido')
        let telaImpressao = window.open('about:blank')
        telaImpressao.document.write(this.htmlImpressao)
        telaImpressao.document.close()// FECHA A JANELA
        telaImpressao.print()
      },
      limparDesconto: function () {
        this.desconto = {percentual: 0, valor: '0,00'}
        this.aplicarDesconto()
      },
      calculaValorDesconto: function (from) {
        this.descontoValor = parseFloat(this.desconto.valor.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
        if ((this.desconto.percentual === 0 && this.descontoValor === 0) || (this.desconto.percentual === '' && this.descontoValor === 0)) {
          this.habilitaDescGeral = false
        } else {
          this.habilitaDescGeral = true
        }
        if (from === 1) {
          if (this.desconto.percentual > 100) {
            this.showMessage('Percentual não pode ser maior que 100%', 'Atenção', 'warning', 'calculaValorDesconto percentual > 100')
            return
          }
          if (this.percLimiteDescontoRepresentante === '' || typeof this.percLimiteDescontoRepresentante === 'undefined') {
            this.percLimiteDescontoRepresentante = 0
          }
          if (this.desconto.percentual > this.percLimiteDescontoRepresentante) {
            this.showMessage('Percentual de desconto não permitido acima de: ' + this.percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'calculaValorDesconto percentual > percLimiteDescontoRepresentante')
            return
          }
        }
        if (from === 2) {
          let itemValUnitFormat = this.pedido.itens.map(function (item) {
            if (typeof item.valorUnitario === 'string') {
              return parseFloat(item.valorUnitario.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace(',', '.'))
            } else {
              return item.valorUnitario
            }
          })
          let totalSomaItens = itemValUnitFormat.reduce((acc, item) => acc + item, 0)
          let calcValorPerc = this.descontoValor * 100 / totalSomaItens
          if (calcValorPerc > this.percLimiteDescontoRepresentante) {
            this.showMessage('Percentual de desconto não permitido acima de: ' + this.percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'calculaValorDesconto calcValorPerc > percLimiteDescontoRepresentante')
            return
          }
          if (this.descontoValor >= this.pedido.totais.valorTotal) {
            this.showMessage('Desconto não pode ser maior ou igual ao valor total do pedido', 'Atenção', 'warning', 'calculaValorDesconto descontoValor > pedido.totais.valorTotal')
            return
          }
        }
      },
      aplicarDesconto: function () {
        let fromInput = 1
        if (this.desconto.valor === 0 && this.desconto.percentual === 0) {
          fromInput = 1
        } else if (this.desconto.percentual > 0) {
          fromInput = 1
        } else {
          fromInput = 2
        }
        let param = {idPedido: this.pedido.id, fromInput: fromInput, percDesconto: this.desconto.percentual, valorDesconto: this.descontoValor}
        this.msgBlockUi = 'Calculando desconto, aguarde...'
        this.blockUiVisibility = true
        pedidosServices.aplicarDesconto(param).then(response => {
          this.refreshPedido(response.data.pedido, response.data.condPagtos)
          console.log(response)
        }).catch(error => {
          console.log(error)
          this.percLimiteDescontoRepresentante = this.dadosAcesso.representante.percLimiteDesconto
         // this.showMessage(error.response.data.mensagem, 'Atenção', 'warning')
          if (this.itemPedido.percDesconto > this.percLimiteDescontoRepresentante) {
            this.showMessage('Percentual de desconto não permitido acima de: ' + this.percLimiteDescontoRepresentante + '%', 'Atenção', 'warning', 'aplicarDesconto erro')
          }
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      changeDesconto: function (fromInput) {
        if (fromInput === 1) {
          this.desconto.valor = 0.00
        } else {
          this.desconto.percentual = 0.00
        }
      },
      adicionarClienteInd: function () {
        this.limparDadosModalPesquisaClienteInd()
        this.modalClienteInd = true
      },
      limparClientInd: function () {
        this.clienteIndustrializadorNome = ''
        this.pedido.codClienteIndustrializador = ''
      },
      limparDadosModalPesquisaClienteInd: function () {
        this.pesquisaClienteInd = {
          termo: '',
          uf: '',
          cidade: ''
        }
        this.clientesPesquisados = []
      },
      selecionarClienteInd: function (clienteIndustrializador) {
        this.pedido.codClienteIndustrializador = clienteIndustrializador.codCliente
        this.clienteIndustrializadorNome = clienteIndustrializador.fantasia
        this.limparDadosModalPesquisaClienteInd()
        this.modalClienteInd = false
      },
      confirmaExclusao: function (id) {
        this.modalExclusao = true
        this.excluirItem = id
      },
      removerItem: function (idItem) {
        let param = { idPedido: this.pedido.id, idPedidoItem: idItem }
        this.msgBlockUi = 'Removendo item, aguarde...'
        this.blockUiVisibility = true
        pedidosServices.removerItem(param).then(response => {
          this.showMessage('Item removido do pedido com sucesso!', 'Sucesso', 'success', 'removerItem ok')
          this.refreshPedido(response.data.pedido, response.data.condPagtos)
          if (this.empresaAsiatex) {
            if (this.pedido.totais.valorTotal <= 1500) {
              this.pedido.tipoFrete = {
                'codigo': '002',
                'descricao': 'FOB'
              }
              this.dadosTabela.fretes = [{
                'codigo': '002',
                'descricao': 'FOB'
              }]
              console.log('menor')
            } else {
              console.log('maior')
            }
          }
          console.log(response)
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'removerItem erro')
        }).finally(() => {
          this.blockUiVisibility = false
          this.modalExclusao = false
        })
      },
      refreshPedido: function (pedido, condPagtos) {
        this.pedido = pedido
        if (this.pedido.itens.length > 0) {
          if (condPagtos.constructor === Array) {
            this.dadosTabela.condPagtos = condPagtos
          } else {
            this.dadosTabela.condPagtos = [condPagtos]
          }
        } else {
          this.dadosTabela.condPagtos = []
        }
        this.clienteIndustrializadorNome = ''
        if (pedido.clienteIndustrializador.fantasia !== undefined) {
          this.clienteIndustrializadorNome = pedido.clienteIndustrializador.fantasia
        }
        if (this.pedido.observacoes.length > 0) {
          for (let indiceObs = 0; indiceObs < this.pedido.observacoes.length; indiceObs++) {
            let observacao = this.pedido.observacoes[indiceObs]
            if (observacao.tipoObservacao === null) {
              observacao.tipoObservacao = {
                codigo: '',
                exibeImpressao: 0,
                descricao: ''
              }
              this.showMessage('Uma ou mais observações foram cadastradas sem o Tipo de Observação, favor corrigir!', 'Atenção', 'danger', 'refreshPedido sem o Tipo de Observação')
            }
          }
        }
      },
      // representante: function () {
      //   let dadosAcesso = localStorage.getItem('dadosAcesso')
      //   if (dadosAcesso.representante.apelido !== 1) {
      //     this.dadosTabela.representante = dadosAcesso.representante.apelido
      //     console.log('s')
      //   //   // dd
      //   }
      // },
      novoPedido: function () {
        this.pedido = {
          id: 0,
          numeroPedido: 0,
          numeroOrcamento: 0,
          statusGoSales: 2,
          isErp: false,
          isEditavel: true,
          chaveErp: '',
          cliente: {},
          clienteIndustrializador: {},
          tabelaPreco: {},
          formaPagto: {},
          condPagto: {},
          tipoFrete: {},
          transportadora: {},
          representante: {},
          observacoes: [],
          itens: [],
          // totais: {}
          totais: {
            valorDesconto: 0,
            valorIPI: 0,
            valorICMSST: 0,
            valorTotal: 0
          }
        }
        this.status = [{
          idStatus: 2,
          codigo: '002',
          ordem: 1,
          chaveErp: '002',
          descricao: 'Orçamento',
          classe: 'col-md-12'
        }]
      },
      novoStatus: function () {
        this.status = [
          {
            idStatus: 1,
            codigo: '001',
            ordem: 1,
            chaveErp: '001',
            descricao: 'Orçamento',
            classe: 'col-md-4'
          },
          {
            idStatus: 2,
            codigo: '002',
            ordem: 2,
            chaveErp: '002',
            descricao: 'Finalizado',
            classe: 'col-md-4'
          },
          {
            idStatus: 3,
            codigo: '003',
            ordem: 3,
            chaveErp: '003',
            descricao: 'Cancelado',
            classe: 'col-md-4'
          }
        ]
      },
      desabilitaCondicaoPagto: function () {
        if (this.desabilitaEdicao()) {
          return true
        } else if (this.pedido.itens.length === 0) {
          return true
        }
        return false
      },
      desabilitaRepresentante: function () {
        if (this.desabilitaEdicao() === true) {
          return true
        } else {
          return this.dadosAcesso.perfil.id === 3
          // this.codigoRepresentante = dadosAcesso.representante.codigo
          // return this.codigoRepresentante === this.pedido.representante.codigo
        }
      },
      desabilitaEdicao: function () {
        if (this.pedido.isErp) {
          return true
        } else {
          return !this.pedido.isEditavel
        }
      },
      selecionarStatus: function (idStatus) {
        if (this.pedido.isErp) {
          return
        } else {
          this.pedido.statusGoSales = idStatus
        }
      },
      editarItemPedido (itemPedido) {
        let param = {codigoGrade: '', codProduto: itemPedido.codProduto, codigoTabelaPreco: this.pedido.tabelaPreco.codigo}
        this.blockUiVisibility = true
        itemPedido.idPedido = this.pedido.id
        let itemPedidoObj = Object.assign({}, itemPedido)
        produtoServices.detalheGrade(param).then(response => {
          let param = {gradeProdutos: response.data, tabela: this.pedido.tabelaPreco, itemPedido: itemPedidoObj}
          // console.log(this.pedido)
          broadcastServer.$emit('editarItemPedido', param)
          this.isModalItensVisible = true
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'editarItemPedido erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      buscarProdutosGrade (grade) {
        let param = {codigoGrade: grade.codigoGrade, codProduto: '', codigoTabelaPreco: this.pedido.tabelaPreco.codigo}
        this.blockUiVisibility = true
        produtoServices.detalheGrade(param).then(response => {
          let param = {gradeProdutos: response.data, tabela: this.pedido.tabelaPreco}
          broadcastServer.$emit('abreModaltens', param)
          this.isModalItensVisible = true
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'buscarProdutosGrade erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      closeModal () {
        this.isModalItensVisible = false
      },
      showMessage: function (message, title, variantColor, from) {
        // console.log('from: ' + from + ' / message: ' + message)
        this.message = message
        this.titleMsg = title
        this.variant = variantColor
        this.$bvToast.show('my-toast-novoPedido')
      },
      addItem: function () {
        if (this.pedido.tabelaPreco.codigo === '' || typeof this.pedido.tabelaPreco.codigo === 'undefined') {
          this.modalItens = false
          this.showMessage('Por favor, selecione uma tabela de preço', 'Atenção', 'danger', 'addItem tabelaPreco.codigo === ""')
          return
        }
        this.pesquisa.termo = ''
        this.grades = []
        this.msgBlockUi = 'Listando itens, aguarde...'
        this.blockUiVisibility = true
        // let pedidoToSend = {
        //   observacoes: []
        // }
        // pedidoToSend.codRpresentante = this.pedido.representante.codigo
        // for (var iObs = 0; iObs < this.pedido.observacoes.length; iObs++) {
        //   let obs = this.pedido.observacoes[iObs]
        //   let newObs = {chaveErp: obs.chaveErp, observacao: obs.observacao, codTipoObs: obs.tipoObservacao.codigo, numPedido: obs.numeroPedido}
        //   pedidoToSend.observacoes.push(newObs)
        // }
        // this.pedido.observacoes = pedidoToSend.observacoes
        let addItem = {
          id: this.pedido.id,
          numeroPedido: this.pedido.numeroPedido,
          numeroOrcamento: this.pedido.numeroOrcamento,
          statusGoSales: this.pedido.statusGoSales,
          isErp: this.pedido.isErp,
          isEditavel: this.pedido.isEditavel,
          chaveErp: this.pedido.chaveErp,
          cliente: {
            cidade: this.pedido.cliente.cidade,
            telefone: this.pedido.cliente.telefone,
            numero: this.pedido.cliente.numero,
            endereco: this.pedido.cliente.endereco,
            ddd: this.pedido.cliente.ddd,
            cnpjCpf: this.pedido.cliente.cnpjCpf,
            codCliente: this.pedido.cliente.codCliente,
            uf: this.pedido.cliente.uf,
            fantasia: this.pedido.cliente.fantasia,
            id: this.pedido.cliente.id,
            idClienteGoSales: this.pedido.cliente.idClienteGoSales,
            clienteNovo: this.pedido.cliente.clienteNovo,
            razaoSocial: this.pedido.cliente.razaoSocial
          },
          clienteIndustrializador: this.pedido.clienteIndustrializador,
          tabelaPreco: {
            codigo: this.pedido.tabelaPreco.codigo,
            tipoFrete: this.pedido.tabelaPreco.tipoFrete,
            calculaImpostos: this.pedido.tabelaPreco.calculaImpostos,
            descricao: this.pedido.tabelaPreco.descricao
          },
          formaPagto: {
            codigo: this.pedido.formaPagto.codigo,
            descricao: this.pedido.formaPagto.descricao
          },
          condPagto: this.pedido.condPagto,
          tipoFrete: {
            codigo: this.pedido.tipoFrete.codigo,
            descricao: this.pedido.tipoFrete.descricao
          },
          transportadora: this.pedido.transportadora,
          representante: this.pedido.representante,
          observacoes: this.pedido.observacoes,
          itens: this.pedido.itens,
          totais: {
            valorDesconto: this.pedido.totais.valorDesconto,
            valorIPI: this.pedido.totais.valorIPI,
            valorICMSST: this.pedido.totais.valorICMSST,
            valorTotal: this.pedido.totais.valorTotal
          }
        }
        if (typeof addItem.cliente.cnpjCpf !== 'undefined') {
          addItem.cliente.telefone = addItem.cliente.telefone.replace('-', '')
          addItem.cliente.ddd = addItem.cliente.ddd.replace('(', '').replace(')', '')
          addItem.cliente.cnpjCpf = addItem.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '')
        } else {
          addItem.cliente = {}
        }
        if (typeof addItem.totais.valorDesconto === 'string') {
          addItem.totais.valorDesconto = parseFloat(addItem.totais.valorDesconto.replace(',', '.'))
        }
        if (typeof addItem.totais.valorIPI === 'string') {
          addItem.totais.valorIPI = parseFloat(addItem.totais.valorIPI.replace(',', '.'))
        }
        if (typeof addItem.totais.valorICMSST === 'string') {
          addItem.totais.valorICMSST = parseFloat(addItem.totais.valorICMSST.replace(',', '.'))
        }
        if (typeof addItem.totais.valorTotal === 'string') {
          addItem.totais.valorTotal = parseFloat(addItem.totais.valorTotal.replace(',', '.'))
        }
        // console.log(JSON.stringify(addItem))
        pedidosServices.inserirPedido(addItem).then(response => {
          // console.log(JSON.stringify(response))
          this.refreshPedido(response.data.pedido, response.data.condPagtos)
          this.novoStatus()
          this.modalItens = true
          this.pesquisa = {}
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'addItem inserirPedido erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      pageLista: function () {
        this.modalVoltarConfirma = false
        broadcastServer.$emit('exibirLista')
        this.clearForm()
      },
      confSairSemSalvar: function () {
        if (JSON.stringify(this.dadosPedidoOriginal) !== JSON.stringify(this.pedido)) {
          this.modalVoltarConfirma = true
        } else {
          this.pageLista()
        }
      },
      valida: function () {
        if (this.pedido.statusGoSales !== 3) {
          if (this.pedido.tabelaPreco.codigo === '' || typeof this.pedido.tabelaPreco.codigo === 'undefined') {
            return 'Por favor, selecione uma tabela de preço'
          }
          if (this.pedido.representante.codigo === '' || typeof this.pedido.representante.codigo === 'undefined') {
            return 'Por favor, selecione o representante'
          }
          // if (this.pedido.condPagto.codigo === '' || typeof this.pedido.condPagto.codigo === 'undefined') {
          //   return 'Por favor, selecione a condição de pagamento'
          // }
          if (this.pedido.itens.length === 0) {
            return 'É necessário que você adicione pelo menos um item antes de salvar'
          }
          if (this.empresaKatec) {
            if (this.pedido.transportadora.codigo === '' || typeof this.pedido.transportadora.codigo === 'undefined') {
              return 'Por favor, selecione a transportadora'
            }
          }
          if (this.empresaMaioricasa || this.empresaAsiatex) {
            if (this.pedido.tipoFrete.codigo === '002') {
              if (this.pedido.transportadora.codigo === '' || typeof this.pedido.transportadora.codigo === 'undefined') {
                return 'Por favor, selecione a transportadora'
              }
            }
          }
          if (this.pedido.statusGoSales === 2) {
            if (this.pedido.condPagto.codigo === '' || typeof this.pedido.condPagto.codigo === 'undefined') {
              return 'Por favor, selecione a condição de pagamento'
            }
          }
          this.pedido.motivoCancelamento = ''
        }
        if (this.pedido.statusGoSales === 3 && this.textoMotivoCancelamento === '') {
          this.modalConfirmaCancelamento = true
          return 'Por favor, preencha o motivo para o cancelamento do pedido'
        } else {
          this.pedido.motivoCancelamento = this.textoMotivoCancelamento
        }
        return ''
      },
      tentaSalvar () {
        if (this.pedido.statusGoSales !== 3) {
          if (this.pedido.tipoFrete.codigo === '' || typeof this.pedido.tipoFrete.codigo === 'undefined') {
            this.modalItens = false
            this.showMessage('Por favor, selecione o tipo de frete', 'Atenção', 'danger', 'tentaSalvar tipoFrete.codigo')
            return
          }
          if (this.pedido.formaPagto.codigo === '' || typeof this.pedido.formaPagto.codigo === 'undefined') {
            this.modalItens = false
            this.showMessage('Por favor, selecione a forma de pagamento', 'Atenção', 'danger', 'tentaSalvar formaPagto.codigo')
            return
          }
        }
        let repLogado = localStorage.getItem('representantesLogin')
        let repSelecionado = localStorage.getItem('representanteSelecionado')
        repLogado = JSON.parse(repLogado)
        repSelecionado = JSON.parse(repSelecionado)
        if (repLogado[0].codigo !== repSelecionado.codigo) {
          this.modalConfirmaRepLog = true
        } else {
          this.salvarPedido()
        }
      },
      salvarPedido () {
        let retValida = this.valida()
        if (retValida !== '') {
          console.log(retValida)
          this.showMessage(retValida, 'Atenção', 'warning', 'salvarPedido retValida !== ""')
          return
        }
        // let pedidoToSend = {
        //   observacoes: []
        // }
        // pedidoToSend.codRpresentante = this.pedido.representante.codigo
        //
        // for (var iObs = 0; iObs < this.pedido.observacoes.length; iObs++) {
        //   let obs = this.pedido.observacoes[iObs]
        //   let newObs = {chaveErp: obs.chaveErp, observacao: obs.observacao, codTipoObs: obs.tipoObservacao.codigo, numPedido: obs.numeroPedido}
        //   pedidoToSend.observacoes.push(newObs)
        // }
        // this.pedido.observacoes = pedidoToSend.observacoes
        // console.log(JSON.stringify('este é o this.pedido -> ' + this.pedido))
        this.msgBlockUi = 'Salvando pedido, aguarde...'
        this.blockUiVisibility = true
        pedidosServices.inserirPedido(this.pedido).then(response => {
          // console.log(JSON.stringify('response do inserir pedido' + response))
          this.refreshPedido(response.data.pedido, response.data.condPagtos)
          this.modalItens = false
          this.modalConfirmaCancelamento = false
          this.pesquisa = {}
          let objectPost = {termo: '', codStatus: 0, emissaoDe: '', emissaoAte: ''}
          broadcastServer.$emit('filtrosSelecionados', objectPost)
          broadcastServer.$emit('exibirLista')
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'salvarPedido inserirPedido erro')
        }).finally(() => {
          this.blockUiVisibility = false
          this.clearForm()
        })
      },
      confirmaExclusaoObs: function (id) {
        this.modalExclusaoObs = true
        this.excluirObs = id
      },
      removerObs: function (indice) {
        let obs = this.pedido.observacoes[indice]
        this.pedido.observacoes.splice(indice, 1)
        // alert(obs.observacao)
        console.log(obs.observacao)
        this.showMessage('Observação removida do pedido com sucesso!', 'Sucesso', 'success', 'removerObs ok')
      },
      alterarObs: function (obs, indice) {
        this.observacao = obs
        this.modalObs = true
        if (this.observacao.tipoObservacao.codigo === '') {
          this.novaObservacao = true
        } else {
          this.novaObservacao = false
        }
        this.indiceObservacaoSelecionada = indice
      },
      clearForm: function () {
        this.dadosTabela = {
          condPagtos: [],
          tabelasPreco: [],
          representante: [],
          fretes: [],
          transportadoras: [],
          formaPagtos: [],
          tiposObservacoes: []
        }
        this.itemCondPagto = {
          codigo: '',
          faixaFinal: 0.00,
          faixaInicial: 0.00,
          descricao: ''
        }
        this.itemTabelaPreco = {
          codigo: '',
          tipoFrete: '',
          calculaImpostos: 0,
          descricao: ''
        }
        this.itemRepresentante = {
          codigo: '',
          apelido: ''
        }
        this.itemFretes = {
          codigo: '',
          descricao: ''
        }
        this.itemTransportadoras = {
          codigo: '',
          descricao: ''
        }
        this.itemFormaPagtos = {
          codigo: '',
          descricao: ''
        }
        this.pedido = {
          chavePedido: 0,
          numeroPedido: '',
          numeroOrcamento: '',
          id: 0,
          statusGoSales: 0,
          isErp: false,
          isEditavel: true,
          chaveErp: '',
          cliente: {},
          clienteIndustrializador: {},
          tabelaPreco: {},
          formaPagto: {},
          condPagto: {},
          tipoFrete: {},
          transportadora: {},
          representante: {},
          observacoes: [],
          itens: [],
          totais: {
            valorDesconto: 0.00,
            valorIPI: 0.00,
            valorICMSST: 0.00,
            valorTotal: 0.00
          }
        }
      },
      clearObs: function () {
        this.observacao = {
          tipoObservacao: {
            codigo: '',
            exibeImpressao: 0,
            descricao: ''
          },
          observacao: '',
          chaveErp: '',
          numeroPedido: ''
        }
      },
      newObs: function () {
        this.clearObs()
        this.modalObs = true
        this.novaObservacao = true
      },
      addObs: function (event) {
        if (this.novaObservacao) {
          let observacoes = this.pedido.observacoes.filter(obs => obs.tipoObservacao.codigo === this.observacao.tipoObservacao.codigo)
          if (observacoes.length > 0) {
            event.preventDefault()
            this.showMessage('Tipo de observação já adicionada, selecione outro tipo para continuar ou edite a observação já disponível.', 'Atenção', 'warning', 'addObs observação já adicionada')
          } else {
            this.pedido.observacoes.push(this.observacao)
            this.modalObs = false
            this.clearObs()
          }
        } else {
          if (this.indiceObservacaoSelecionada !== -1) {
            this.pedido.observacoes[this.indiceObservacaoSelecionada].observacao = this.observacao.observacao
            this.newObs()
            this.indiceObservacaoSelecionada = -1
          } else {
            this.showMessage('Problemas ao obter observação selecionada', 'Atenção', 'warning', 'addObs Problemas ao obter observação selecionada')
          }
        }
      },
      disableSalvarObs: function () {
        return this.observacao.observacao === '' || this.observacao.tipoObservacao.codigo === ''
      },
      disableEnviarCancelamento: function () {
        return this.textoMotivoCancelamento === ''
      },
      fechaModalCancelamento: function () {
        this.modalConfirmaCancelamento = false
        this.tentaSalvar()
      },
      formatterValue (value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      formatQtde: function (qtde) {
        if (typeof qtde !== 'undefined') {
          return qtde.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }
      },
      limpaPesq: function () {
        this.grades = []
      },
      pesquisarGrades: function () {
        if (this.pesquisa.termo.length <= 2) {
          this.showMessage('Digite ao menos três caracteres.', 'Atenção', 'warning', 'pesquisarGrades pesquisa.termo.length <= 2')
          return
        }
        this.blockUiVisibility = true
        produtoServices.pesquisarGrades(this.pesquisa.termo).then(response => {
          this.grades = response.data.grades
          if (this.grades.length === 0) {
            this.showMessage('Não existe produto com nome semelhante ao pesquisado, tente novamente', 'Atenção', 'warning', 'pesquisarGrades grades.length === 0')
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'pesquisarGrades erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      pesquisarClienteInd: function () {
        if (this.pesquisaClienteInd.termo.length <= 2) {
          this.showMessage('Digite ao menos três caracteres.', 'Atenção', 'warning', 'pesquisarClienteInd .termo.length <= 2')
          return
        }
        this.blockUiVisibility = true
        this.pesquisaClienteInd.uf = ''
        this.pesquisaClienteInd.cidade = ''
        clienteServices.listarSelect(this.pesquisaClienteInd).then(response => {
          this.clientesPesquisados = response.data.clientes
          if (this.clientesPesquisados.length === 0) {
            this.showMessage('Não existe cliente com nome semelhante ao pesquisado, tente novamente', 'Atenção', 'warning', 'pesquisarClienteInd listarSelect clientesPesquisados.length === 0')
          }
        }).catch(error => {
          console.log(error)
          this.showMessage('Aconteceu alguma coisa!' + error, 'Atenção', 'danger', 'pesquisarClienteInd erro')
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      reset () {  /** TRECHO RESPONSÁVEL PELA FILTRAGEM DO SELECT **/
        this.itemCondPagto = {}
      },
      selectFromParentComponent1 () {
        // select option from parent component
        this.itemCondPagto = this.dadosTabela.condPagtos[0]
        /** FIM COD DE FILTRO DO SELECT **/
      },
      formatterCnpjCpf: function (value) {
        if (value.length === 14) {
          value = value.replace(/^(\d{2})(\d)/, '$1.$2')
          value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
          value = value.replace(/\.(\d{3})(\d)/, '.$1/$2')
          value = value.replace(/(\d{4})(\d)/, '$1-$2')
          return value
        }
        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d)/, '$1.$2')
          value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
          return value
        }
      }
    }
  }
</script>
<style scoped>
  .progressbar{
    counter-reset: step;
  }
  .progressbar button {
    display: inline;
    float: left;
    position: relative;
    text-align: center;
    color: #fff;
    border-radius: 18px;
    line-height: 34px;
  }
  .title {
    font-weight: 600;
    text-align: left;
    font-family: 'Didact Gothic', sans-serif;
  }
  .text-divider:before {
    float: right;
    /* width: 76%; */
    width: 100%;
  }
  .text-divider2:before {
    float: right;
    width: 76%;
  }
  .title2 {
    font-weight: 600;
    text-align: left;
    font-family: 'Didact Gothic', sans-serif;
    font-size: 20px;
  }
  .text-divider3:before {
    float: right;
    width: 46%;
    margin-right: 26px;
  }
  .align-table{
    vertical-align: middle
  }
  label.labelSelect {
    display: block;
    width: 100%;
    text-align: left;
  }
  .ui.selection.dropdown {
    padding: 13px !important;
  }
  .table {
    overflow-y: auto;
    position: relative;
    min-height: 60px;
    max-height: 380px;
    font-size: 14px;
    margin-top: 10px;
  }
  .cardItem {
    margin: 0 auto;
    padding: 0;
  }
  .table td {
    vertical-align: middle;
  }
  .color {
    background-color: rgb(55, 71, 79);
  }
  .colorSelec {
    background-color: rgb(38, 50, 56);
  }
  .imgTable {
    width: 100px;
  }
  .card-img {
    box-shadow: 5px 10px 20px 0px rgba(183, 183, 183, 0.75);
  }
  .imgTable img {
    max-width: 100%;
    max-height: 70px;
  }
  #imgOrigem {
    background-color: #fff;
  }
  #imgOrigem img {
    max-width: 100%;
    max-height: 25px;
  }
  #cardObs .form-row .btn {
    margin: 0 1%;
    -ms-flex: 0 0 48%;
    flex: 0 0 48%;
    max-width: 48%;
  }
  #pedTotaisPed .form-row div {
    border: 1px solid #dedede;
    border-radius: calc(.3rem - 1px) calc(.3rem - 1px) calc(.3rem - 1px) calc(.3rem - 1px) !important;
    margin: 0;
    background: #fcfcfc;
    padding: 5px 10px;
  }
  #pedTotaisPed .form-row div p {
    margin: 0;
  }
  #impressaoPedido {
    overflow-y: scroll
  }
  .semImagemItem {
    max-width: 100%;
    width: auto;
    max-height: 80px;
  }
  .imgItem {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
  .imgItem img {
    max-width: 100%;
    border-radius: calc(.25rem - 1px);
    -webkit-box-shadow: 5px 10px 20px 0px rgba(183, 183, 183, 0.75);
    box-shadow: 5px 10px 20px 0px rgba(183, 183, 183, 0.75);
  }
</style>




// WEBPACK FOOTER //
// src/components/items/NovoPedidoVue.vue